<template>
    <div class="app-container">
      <h1>作业批改</h1>

      <!-- 顶部统计和创建按钮 -->
      <div class="header-bar">
        <span class="total-count">共{{ totalHomeworks }}道题</span>
        <div class="buttons-group">
          <button class="create-btn" @click="showCreateDialog">
            + 创建作业
          </button>
          <button class="image-create-btn" @click="showImageHomeworkCreator">
            + 自建作业
          </button>
        </div>
        <!-- <el-button type="primary" @click="testuser">测试id查询用户</el-button> -->
        <!-- <el-button type="primary" @click="test">测试按钮</el-button> -->
      </div>

      <!-- 作业列表 -->
      <div v-if="homeworkList.length > 0">
        <table class="homework-table">
          <thead>
            <tr>
              <th>作业名称</th>
              <th>创建时间</th>
              <th>创建人</th>
              <th>发布班级</th>
              <th>发布状态</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody v-loading="loading">
            <tr v-for="(homework) in homeworkList" :key="homework.id">
              <td><span class="view-btn" @click="handleHomeworkNameClick(homework)">{{ homework.name }}</span></td>
              <td>{{ homework.createTime }}</td>
              <td>{{ homework.createPersonName || homework.createPerson }}</td>
              <td>{{ getPublishedClassesDisplay(homework) }}</td>
              <td>{{ homework.publishStatus || (homework.published ? '已发布' : '未发布') }}</td>
              <td class="action-column">
                <span class="edit-btn" @click="editHomework(homework)">编辑</span>
                <span class="publish-btn" @click="publishHomework(homework.id)">
                  {{ homework.published ? '重新发布' : '发布' }}
                </span>
                <span class="delete-btn" @click="deleteHomework(homework.id)">删除</span>
                <span class="batch-upload-btn" @click="openBatchUpload(homework)">批量上传</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 空状态提示 -->
      <div v-else-if="!loading" class="empty-state">
        <div class="empty-icon">📝</div>
        <div class="empty-message">目前没有作业，请新建作业！</div>
      </div>

      <!-- 编辑作业对话框 -->
      <el-dialog title="作业编辑器" :visible.sync="editDialogVisible" width="80%" :before-close="handleClose">
        <div class="homework-editor">
          <div class="editor-container">
            <div class="editor-left">
              <h3>题目列表</h3>
              <!-- 添加OCR识别按钮和手动输入按钮 -->
              <div class="knowledge-select">
                <el-button type="primary" size="small" @click="showOcrDialog" style="margin-right: 10px;">
                  OCR识别题目
                </el-button>
                <el-button type="primary" size="small" @click="showInputDialog" style="margin-right: 10px;">
                  手动输入题目
                </el-button>
                <el-select v-model="selectedCourseFolderId" placeholder="选择课程题库文件夹" style="width: 260px; margin-right: 10px" @change="loadQuestionsBySelectedFolder" @visible-change="onCourseFolderDropdownVisible">
                  <el-option v-for="f in courseFolders" :key="f.id" :label="f.fullName" :value="f.id" />
                </el-select>
                <el-select v-model="selectedKnowledgePoint" placeholder="请选择知识点" style="width: 200px; margin-right: 10px">
                  <el-option v-for="item in knowledgePoints" :key="item.id" :label="item.content" :value="item.content" />
                </el-select>
                <el-select v-model="selectedRepoId" placeholder="请选择题库" style="width: 200px; margin-right: 10px">
                  <el-option v-for="item in repoList" :key="item.id" :label="item.title" :value="item.id" />
                </el-select>
                <el-button type="primary" size="small" @click="searchQuestions">查询</el-button>
                <el-button size="small" @click="resetQuestions" style="margin-left: 8px;">重置</el-button>
              </div>

              <!-- 题目列表区域 -->
              <div class="question-list" v-loading="questionsLoading">
                <div v-if="showEmptyState" class="empty-state">
                  <p>目前还没有创建题目</p>
                  <p>您可以点击上方的"手动输入题目"或"OCR识别题目"来添加题目</p>
                </div>
                <div v-else class="question-items">
                  <el-checkbox-group v-model="selectedQuestions">
                    <div v-for="question in questionList" :key="question.id" class="question-item">
                      <el-checkbox :label="question.id">
                        <div class="question-content">
                          <div class="question-title" v-html="renderMathFormula(question.content || '-')" style="line-height: 1.6;"></div>
                          <div class="question-info">
                            <span>题型：{{ getQuestionType(question.quType || question.type) }}</span>
                            <span>题库：{{ question.bankName || getRepoName(question.repoId) }}</span>
                            <span>文件夹：{{ question.folderName || '-' }}</span>
                            <span>难度：{{ question.difficulty || '-' }}</span>
                          </div>
                        </div>
                      </el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
              </div>

              <!-- 底部操作按钮 -->
              <div class="question-actions">
                <el-checkbox v-model="selectAllQuestions" @change="onToggleSelectAll" style="margin-right: 12px;">
                  全选
                </el-checkbox>
                <el-button type="primary" size="small" @click="addSelectedQuestions" :disabled="selectedQuestions.length === 0">
                  添加选中题目 ({{ selectedQuestions.length }})
                </el-button>
              </div>
            </div>
            <div class="editor-right">
              <h3>作业预览</h3>
              <div class="preview-area">
                <div v-if="!currentHomework.questions || currentHomework.questions.length === 0" class="empty-state">
                  <p>暂无题目</p>
                  <p>请从左侧选择题目添加</p>
                </div>
                <div v-else class="preview-questions">
                  <div v-for="(question, index) in currentHomework.questions" :key="question.id"
                    class="preview-question-item">
                    <div class="question-header">
                      <span class="question-number">第{{ index + 1 }}题</span>
                      <el-button type="text" class="delete-btn" @click="removeQuestion(index)">
                        删除
                      </el-button>
                    </div>
                    <div class="question-body">
                      <div class="question-content" v-html="renderMathFormula(question.content)" style="line-height: 1.6;"></div>
                      <div class="question-info">
                        <span>题型：{{ getQuestionType(question.quType) }}</span>
                        <span>题库：{{ getRepoName(question.repoId) }}</span>
                        <span>分数：{{(question.point) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 题型统计和总分栏 -->
              <div class="question-summary-bar" v-if="currentHomework.questions && currentHomework.questions.length">
                <div style="display: flex; justify-content: space-between; align-items: center; padding: 12px 0; border-top: 1px solid #e4e7ed; margin-top: 10px;">
                  <div>
                    <span v-for="(count, type) in questionTypeCount" :key="type" style="margin-right: 18px;">
                      {{ getQuestionType(type) }}：{{ count }}道
                    </span>
                  </div>
                  <div>
                    总分：{{ totalPoints }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveHomework">保 存</el-button>
        </span>
      </el-dialog>

      <!-- 学生列表弹窗 -->
      <el-dialog :visible.sync="studentListVisible" width="80%">
        <div slot="title" class="dialog-title">
          <span>学生提交列表 - {{ currentHomework.submissionCount || 0 }}/{{ currentHomework.totalStudents || 0 }}</span>
          <el-tag size="mini" type="info" style="margin-left: 10px;">
            <i class="el-icon-sort"></i>
            按批改状态排序
          </el-tag>
        </div>
        <!-- 班级标签选择器 -->
        <div class="class-tags-container" v-if="homeworkClasses && homeworkClasses.length > 0">
          <div class="class-tags-header">
            <span class="tags-label">发布班级：</span>
            <el-tag
              v-for="classInfo in homeworkClasses"
              :key="classInfo.id"
              :type="selectedClassId === classInfo.id ? 'primary' : 'info'"
              :effect="selectedClassId === classInfo.id ? 'dark' : 'plain'"
              class="class-tag"
              @click="selectClass(classInfo.id)"
            >
              <span class="class-icon">🎓</span>
              <span class="class-name">{{ classInfo.grade_name }}</span>
              <span class="class-id">({{ classInfo.id }})</span>
              <span class="submission-count">{{ getClassStudentCount(String(classInfo.id)) }}</span>
            </el-tag>
          </div>
        </div>

        <!-- 添加统计信息卡片 -->
        <div class="stats-cards" v-if="Object.keys(homeworkStats).length > 0">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-card class="stats-card">
                <div class="stats-card-content">
                  <div class="stats-card-title">完成率</div>
                  <div class="stats-card-value">{{ homeworkStats.completionRate }}%</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="stats-card">
                <div class="stats-card-content">
                  <div class="stats-card-title">平均分</div>
                  <div class="stats-card-value">{{ homeworkStats.averageScore }}</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="stats-card">
                <div class="stats-card-content">
                  <div class="stats-card-title">分数分布</div>
                  <div class="score-distribution-mini">
                    <div v-for="(count, range) in homeworkStats.scoreDistribution" :key="range" class="distribution-item-mini">
                      <span class="range-label-mini">{{ range }}:</span>
                      <span class="count-value">{{ count }}人</span>
                    </div>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>

        <!-- 排序规则说明 -->
        <div class="sorting-info" style="margin: 15px 0; padding: 12px; background: #f0f9ff; border-radius: 6px; border-left: 4px solid #0ea5e9;">
          <div style="font-size: 13px; color: #0369a1; display: flex; align-items: center;">
            <i class="el-icon-info" style="margin-right: 6px;"></i>
            <span><strong>排序规则：</strong>未提交 → 未批改 → 已批改（同状态内按学号排序）</span>
          </div>
        </div>

        <!-- 学生列表 -->
        <div v-if="!selectedClassId" class="no-class-selected">
          <el-alert
            title="请选择一个班级查看学生列表"
            type="info"
            :closable="false"
            show-icon>
          </el-alert>
        </div>
        <el-table v-else :data="filteredStudents" border style="width: 100%">
          <el-table-column prop="student_num" label="学号" width="120"></el-table-column>
          <el-table-column prop="name" label="学生姓名" width="120">
            <template slot-scope="scope">
              <span class="student-name" @click="showCorrectionResult(scope.row)">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <!-- 调试信息列 -->
          <el-table-column label="信息" width="200" align="center">
            <template slot-scope="scope">
              <div style="font-size: 12px; color: #666;">
                <div><strong>ID:</strong> {{ scope.row.id }}</div>
                <div><strong>Student_ID:</strong> {{ scope.row.id }}</div>
                <div><strong>作业ID:</strong> {{ currentHomework ? currentHomework.id : 'N/A' }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="150" align="center">
            <template slot-scope="scope">
              <el-tag :type="getSubmissionStatus(scope.row).type" size="small">
                {{ getSubmissionStatus(scope.row).text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="上传作业图片" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="getSubmissionStatus(scope.row).text === '未提交'"
                type="primary"
                size="mini"
                icon="el-icon-upload"
                @click="showUploadDialog(scope.row)"
              >
                上传作业图片
              </el-button>
              <el-button
                v-else-if="getSubmissionStatus(scope.row).text === '未批改' || getSubmissionStatus(scope.row).text === '已批改'"
                type="warning"
                size="mini"
                icon="el-icon-refresh"
                @click="showReuploadDialog(scope.row)"
              >
                重新上传作业图片
              </el-button>
              <span v-else style="color: #999;">-</span>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="studentListVisible = false">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 批改结果弹窗 -->
      <el-dialog title="作业批改结果" :visible.sync="correctionResultVisible" width="80%">
        <!-- 调试信息显示 -->
        <div class="debug-info" style="background: #f0f9ff; border: 1px solid #0ea5e9; border-radius: 6px; padding: 12px; margin-bottom: 16px;">
          <h4 style="margin: 0 0 8px 0; color: #0369a1; font-size: 14px;">🔍 信息</h4>
          <div style="display: flex; gap: 20px; font-size: 13px; color: #0c4a6e;">
            <div><strong>学生ID:</strong> {{ currentStudent ? currentStudent.id : 'N/A' }}</div>
            <div><strong>学号:</strong> {{ currentStudent ? currentStudent.student_num : 'N/A' }}</div>
            <div><strong>学生姓名:</strong> {{ currentStudent ? currentStudent.name : 'N/A' }}</div>
            <div><strong>作业ID:</strong> {{ currentHomework ? currentHomework.id : 'N/A' }}</div>
            <div><strong>作业名称:</strong> {{ currentHomework ? currentHomework.name : 'N/A' }}</div>
          </div>
          <!-- <div style="margin-top: 8px; font-size: 12px; color: #64748b;">
            <div><strong>查询条件:</strong> student_id = {{ currentStudent ? currentStudent.id : 'N/A' }}, homework_id = {{ currentHomework ? currentHomework.id : 'N/A' }}</div>
            <div><strong>提交记录数:</strong> {{ studentSubmissions ? studentSubmissions.length : 0 }}</div>
            <div><strong>批改结果数:</strong> {{ correctionResults ? correctionResults.length : 0 }}</div>
          </div> -->
          </div>
        <el-button
              type="success"
              @click="recognizeStudentAnswers"
              :loading="recognizing"
              :disabled="!studentImageUrl || recognizing"
              style="margin-right: 10px;"
            >
              <i class="el-icon-view" style="margin-right: 5px;"></i>
              {{ recognizing ? '识别中...' : '识别学生作答结果' }}
            </el-button>
        <div class="correction-dialog-body-beauty">
          <div class="correction-image-beauty">
            <img
              v-if="studentImageUrl"
              :src="studentImageUrl"
              alt="作业图片"
              :style="{
                maxWidth: '100%',
                maxHeight: '700px',
                borderRadius: '12px',
                boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
                background: '#fff',
                padding: '12px',
                cursor: dragging ? 'grabbing' : 'grab',
                transform: `scale(${imageScale}) translate(${imageOffset.x}px, ${imageOffset.y}px)`,
                transition: dragging ? 'none' : 'transform 0.2s',
                position: dragging ? 'absolute' : 'static',
                zIndex: dragging ? 10 : 'auto',
                left: 0,
                top: 0
              }"
              @wheel.prevent="handleImageWheel"
              @mousedown="startDrag"
            />
            <div v-else class="no-image">暂无图片</div>
            <div class="zoom-tip">滚轮缩放，拖拽图片</div>
            <!-- 添加图片切换控制 -->
            <div class="image-navigation" v-if="studentSubmissions.length > 1">
              <!-- 调试信息 -->
              <!-- <div style="font-size: 12px; color: #999; margin-bottom: 5px;">
                调试: studentSubmissions.length = {{ studentSubmissions.length }}, currentImageIndex = {{ currentImageIndex }}
              </div> -->
              <el-button
                :disabled="currentImageIndex === 0"
                @click="prevImage"
                icon="el-icon-arrow-left"
              >上一张</el-button>
              <span class="image-counter">{{ currentImageIndex + 1 }}/{{ studentSubmissions.length }}</span>
              <el-button
                :disabled="currentImageIndex === studentSubmissions.length - 1"
                @click="nextImage"
                icon="el-icon-arrow-right"
              >下一张</el-button>
            </div>
          </div>
          <div class="correction-table-beauty">
            <div class="student-info" v-if="currentStudent">
              <h3>学生：{{ currentStudent.username }} <span v-if="currentStudentScore !== null">- 得分: {{ currentStudentScore }}</span></h3>
            </div>
            <el-table :data="correctionResults" border style="width: 100%">
              <el-table-column label="序号" type="index" width="50" align="center" />
              <el-table-column prop="stem" label="题目" min-width="150">
                <template slot-scope="scope">
                  <div v-html="renderMathFormula(scope.row.stem)" style="font-size: 12px; line-height: 1.4;"></div>
                </template>
              </el-table-column>
              <el-table-column label="学生答案" min-width="120">
                <template slot-scope="scope">
                  <div class="student-answer">
                    <!-- 图片答案 -->
                    <div v-if="scope.row.answerImageUrl" class="answer-image">
                      <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-view"
                        @click="previewImage(scope.row.answerImageUrl)"
                      >
                        {{ Array.isArray(scope.row.answerImageUrl) ? `查看图片(${scope.row.answerImageUrl.length})` : '查看图片' }}
                      </el-button>
                    </div>
                    <!-- 文字答案 -->
                    <div v-if="scope.row.answerText" class="answer-text">
                      <div v-html="renderMathFormula(scope.row.answerText)" style="font-size: 12px; line-height: 1.4;"></div>
                    </div>
                    <!-- 无答案 -->
                    <div v-if="!scope.row.answerText && !scope.row.answerImageUrl" class="no-answer">
                      <span style="color: #999; font-size: 12px;">未作答</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="point" label="分数" width="80" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.point" size="small" placeholder="分数" type="number" min="0" style="width: 70px;" />
                </template>
              </el-table-column>
              <el-table-column prop="judge" label="结果" width="100" align="center">
                <template slot-scope="scope">
                  <el-dropdown @command="val => handleJudgeChange(scope.$index, val)">
                    <el-tag
                      :type="scope.row.judge === '正确' ? 'success' : (scope.row.judge === '错误' ? 'danger' : 'info')"
                      style="cursor:pointer"
                    >
                      {{ scope.row.judge || '未批改' }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-tag>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="正确">
                        <el-tag type="success">正确</el-tag>
                      </el-dropdown-item>
                      <el-dropdown-item command="错误">
                        <el-tag type="danger">错误</el-tag>
                      </el-dropdown-item>
                      <el-dropdown-item command="未批改">
                        <el-tag type="info">未批改</el-tag>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
              <el-table-column prop="comment" label="评语" min-width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.comment" placeholder="请输入评语" size="small" />
                </template>
              </el-table-column>
            </el-table>

            <!-- 整体作业评语 -->
            <div class="homework-comment-section" style="margin-top: 20px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e9ecef;">
              <h4 style="margin: 0 0 15px 0; color: #495057; font-size: 16px;">
                <i class="el-icon-edit" style="margin-right: 8px;"></i>
                整体作业评语
              </h4>
              <el-input
                v-model="homeworkComment"
                type="textarea"
                :rows="4"
                placeholder="请输入对整体作业的评价和建议..."
                maxlength="500"
                show-word-limit
                style="width: 100%;"
              />
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer" style="display: flex; flex-direction: column; align-items: center;">
          <div style="margin-bottom: 15px;">
            <el-checkbox v-model="autoAddToWrongBook" style="margin-right: 20px;">
              自动将错误题目添加到学生错题本
            </el-checkbox>
            <span v-if="autoAddToWrongBook && errorQuestionCount > 0" style="color: #E6A23C; font-size: 12px;">
              (将添加 {{ errorQuestionCount }} 道错误题目)
            </span>
          </div>
          <div>
            <el-button :disabled="currentPage === 1" @click="prevPage">上一页</el-button>
            <span style="margin: 0 15px;">第{{ currentPage }}/{{ totalPages }}页</span>
            <el-button :disabled="currentPage === totalPages" @click="nextPage">下一页</el-button>
          </div>
          <div style="margin-bottom: 20px;">
            <el-button @click="closeCorrectionDialog">关 闭</el-button>

            <el-button type="primary" @click="saveCorrectionResults">保存</el-button>
          </div>
        </span>
      </el-dialog>

      <!-- 学生作业图片 -->
      <el-dialog
        :title="`学生作业图片 (${currentImageIndex + 1}/${studentImages.length})`"
        :visible.sync="studentImageDialogVisible"
        width="60%"
      >
        <div class="image-viewer-container">
          <!-- 图片显示区域 -->
          <div class="image-display-area" v-if="studentImages.length > 0">
            <img
              :src="studentImages[currentImageIndex]"
              alt="作业图片"
              style="max-width:100%;max-height:500px;display:block;margin:auto;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.1);"
            />
          </div>

          <!-- 图片切换控制 -->
          <div class="image-controls" v-if="studentImages.length > 1">
            <el-button
              type="primary"
              icon="el-icon-arrow-left"
              :disabled="currentImageIndex === 0"
              @click="viewerPreviousImage"
              size="small"
            >
              上一张
            </el-button>
            <span class="image-counter">{{ currentImageIndex + 1 }} / {{ studentImages.length }}</span>
            <el-button
              type="primary"
              icon="el-icon-arrow-right"
              :disabled="currentImageIndex === studentImages.length - 1"
              @click="viewerNextImage"
              size="small"
            >
              下一张
            </el-button>
          </div>

          <!-- 图片缩略图 -->
          <div class="image-thumbnails" v-if="studentImages.length > 1">
            <div
              v-for="(image, index) in studentImages"
              :key="index"
              class="thumbnail-item"
              :class="{ active: index === currentImageIndex }"
              @click="selectImage(index)"
            >
              <img :src="image" :alt="`图片${index + 1}`" />
            </div>
          </div>

          <!-- 无图片提示 -->
          <div v-if="studentImages.length === 0" class="no-images">
            <i class="el-icon-picture" style="font-size:48px;color:#ccc;"></i>
            <p>暂无作业图片</p>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="studentImageDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 上传作业图片弹窗 -->
      <el-dialog
        :title="`${uploadDialogTitle} - ${currentUploadStudent ? currentUploadStudent.name : ''}`"
        :visible.sync="uploadImageDialogVisible"
        width="50%"
        :before-close="handleUploadDialogClose"
      >
        <div class="upload-container">
          <div class="upload-info">
            <p><strong>学生姓名：</strong>{{ currentUploadStudent ? currentUploadStudent.name : '' }}</p>
            <p><strong>学号：</strong>{{ currentUploadStudent ? currentUploadStudent.student_num : '' }}</p>
            <p><strong>作业名称：</strong>{{ currentHomework ? currentHomework.name : '' }}</p>
          </div>

          <div class="upload-area">
            <el-upload
              class="upload-demo"
              drag
              action="#"
              :auto-upload="false"
              :on-change="handleUploadFileChange"
              :on-remove="handleUploadFileRemove"
              :file-list="uploadFileList"
              accept="image/*"
              :limit="10"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将作业图片拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">支持多张图片上传，最多10张，只能上传jpg/png文件，且每张不超过10MB</div>
            </el-upload>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="uploadImageDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitUploadImage"
            :loading="uploadingImage"
            :disabled="uploadFileList.length === 0"
          >
            {{ uploadingImage ? '上传中...' : '确认上传' }}
          </el-button>
        </span>
      </el-dialog>

      <!-- OCR识别对话框 -->
      <el-dialog
        title="OCR识别题目"
        :visible.sync="ocrDialogVisible"
        width="30%"
        :before-close="handleOcrDialogClose"
      >
        <div class="upload-container">
          <div style="margin-bottom: 10px; font-weight: 600;">题目图片</div>
          <!-- <div class="question-type-select">
            <span class="label">请选择题目类型：</span>
            <el-radio-group v-model="selectedQuType">
              <el-radio v-for="item in quTypeOptions" :key="item.value" :label="item.value">
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </div> -->
          <el-upload
            class="upload-demo"
            drag
            action="#"
            :auto-upload="false"
            multiple
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :file-list="fileList"
            accept="image/*"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>（可多选）</div>
            <div class="el-upload__tip" slot="tip">支持多张图片，建议jpg/png</div>
          </el-upload>

          <div style="margin: 20px 0 10px; font-weight: 600;">参考答案图片（可选）</div>
          <el-upload
            class="upload-demo"
            drag
            action="#"
            :auto-upload="false"
            :on-change="handleAnswersFileChange"
            :on-remove="handleAnswersFileRemove"
            :file-list="answersFileList"
            accept="image/*"
            :limit="1"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">拖拽或点击选择参考答案图片（1张，可不选）</div>
            <div class="el-upload__tip" slot="tip">不提供则传递参数 answers=null</div>
          </el-upload>
        </div>
        <div class="dialog-footer" slot="footer">
          <el-button @click="ocrDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleImageUpload">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 手动输入题目对话框 -->
      <el-dialog
        title="手动输入题目"
        :visible.sync="inputDialogVisible"
        width="50%"
      >
        <el-form :model="inputQuestionForm" label-width="100px">
          <el-form-item label="题目类型">
            <el-select v-model="inputQuestionForm.quType" placeholder="请选择题目类型">
              <el-option
                v-for="item in quTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="题目内容">
            <el-input
              type="textarea"
              v-model="inputQuestionForm.content"
              :rows="4"
              placeholder="请输入题目内容"
            />
          </el-form-item>
          <el-form-item label="答案">
            <el-input
              type="textarea"
              v-model="inputQuestionForm.answer"
              :rows="2"
              placeholder="请输入答案"
            />
          </el-form-item>
          <el-form-item label="选项" v-if="inputQuestionForm.quType === 1">
            <el-input
              type="textarea"
              v-model="inputQuestionForm.options"
              :rows="3"
              placeholder="请输入选项，格式：A.选项1;B.选项2;C.选项3;D.选项4"
            />
          </el-form-item>
          <el-form-item label="知识点">
            <el-input
              v-model="inputQuestionForm.knowledge"
              placeholder="请输入知识点"
            />
          </el-form-item>
          <el-form-item label="解析">
            <el-input
              type="textarea"
              v-model="inputQuestionForm.analysis"
              :rows="2"
              placeholder="请输入解析"
            />
          </el-form-item>
          <el-form-item label="评价">
            <el-input
              type="textarea"
              v-model="inputQuestionForm.evaluate"
              :rows="2"
              placeholder="请输入题目评价"
            />
          </el-form-item>
          <el-form-item label="难度">
            <el-slider
              v-model="inputQuestionForm.difficulty"
              :min="0"
              :max="1"
              :step="0.1"
              show-input
              :format-tooltip="formatDifficulty"
            />
          </el-form-item>
          <el-form-item label="等级">
            <el-input-number
              v-model="inputQuestionForm.level"
              :min="1"
              :max="5"
              placeholder="题目等级"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="inputDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleInputQuestion">添 加</el-button>
        </span>
      </el-dialog>

      <!-- 新建作业对话框 -->
      <el-dialog
        title="新建作业"
        :visible.sync="createDialogVisible"
        width="30%"
        @close="handleCreateDialogClose"
      >
        <el-form :model="newHomeworkForm" label-width="80px">
          <el-form-item label="作业名称">
            <el-input
              v-model="newHomeworkForm.name"
              placeholder="请输入作业名称"
              @keyup.enter="handleCreateHomework"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="createDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleCreateHomework">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 自建作业组件 -->
      <ImageHomeworkCreator
        ref="imageHomeworkCreator"
        :visible.sync="imageHomeworkCreatorVisible"
        @success="handleImageHomeworkCreated"
      />

      <!-- 批量上传对话框 -->
      <el-dialog
        title="批量上传学生作业"
        :visible.sync="batchUploadVisible"
        width="90%"
        :close-on-click-modal="true"
        :modal="true"
        :lock-scroll="false"
      >
        <CourseClassHomeworkUpload
          v-if="batchUploadVisible && currentBatchHomework && currentBatchHomework.id"
          :key="`homework-${currentBatchHomework.id}-${Date.now()}`"
          :homework="currentBatchHomework"
          :courseId="courseId"
        />
        <div v-else-if="batchUploadVisible" class="loading-container" style="min-height: 200px; display: flex; align-items: center; justify-content: center;">
          <div class="loading-content">
            <i class="el-icon-loading"></i>
            <p>正在加载批量上传组件...</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="batchUploadVisible = false">关 闭</el-button>
          <el-button type="primary" @click="testComponent">测试组件</el-button>
          <el-button type="success" @click="forceShowUploadContent">强制显示内容</el-button>
        </span>
      </el-dialog>

      <!-- 发布作业对话框 -->
      <el-dialog
        title="发布作业"
        :visible.sync="publishDialogVisible"
        width="40%"
      >
        <el-form :model="publishForm" label-width="100px">
          <el-form-item label="作业名称">
            <el-input v-model="publishForm.name" disabled />
          </el-form-item>
          <el-form-item label="选择班级" required>
            <el-select
              v-model="publishForm.selectedClassIds"
              multiple
              filterable
              placeholder="请选择要发布的班级"
              style="width: 100%"
            >
              <el-option
                v-for="item in classList"
                :key="item.id"
                :label="getClassDisplayName(item)"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="publishDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handlePublishHomework">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>

  <script>
  import { mapGetters } from 'vuex'
  import { Loading } from 'element-ui'
  import ImageHomeworkCreator from './ImageHomeworkCreator.vue'
  import CourseClassHomeworkUpload from '@/components/CourseClassHomeworkUpload'
  import {
    getHomeworkList,
    getHomeworkListByCourseId,
    getHomeworkListByUserIdAndCourseId,
    createHomework,
    deleteHomework,
    getKnowledgeContent,
    getQuestionsByKnowledge,
    getTop50Questions,
    getSpecificHomeworkQuestions,
    getQuestionDetailsByHomeworkId,
    saveSpecificHomework,
    getStudentUsername,
    getCorrectionResult,
    saveCorrectionResults,
    getQuestionDetail,
    getHomeworkStats,
    updateCorrectionStatus,
    getImageHomeworkList,
    deleteImageHomework,
    publishImageHomework,
    publishHomeworkSingle,
    publishHomeworkMultiple,
    getHomeworkClassesAndStudents
  } from '@/api/homework';
  import { classPaging } from '@/api/class';
  import { processOcrImage, getQuestionsByRepoId, saveOcrQuestions, quDetailbyContent } from '@/api/question';
  import { addWrongQuestion } from '@/api/userbook';
  import { fetchPaging } from '@/api/repo';
  import { getCourseQuestions, getQuestionBanksByCourseId, getQuestionBankFolderTree, getFolderQuestions } from '@/api/questionBank';
  import { getUsersByGradeId } from '@/api/user';
  import {
    getSubmitByStudentIdAndHomeworkId,
    getSubmitDetails,
    gradeHomework,
    uploadHomeworkImage,
    reuploadHomeworkImage
  } from '@/api/homeworkSubmit';

  export default {
    name: 'homework-correct',
    components: {
      ImageHomeworkCreator,
      CourseClassHomeworkUpload
    },
    props: {
      courseId: {
        type: [String, Number],
        default: null
      },
      isTeacher: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        testdata: [
          {
            'suboptions': '数学',
            'textbookOptions': '人教版',
            'gradeoptions': 3
          }
        ],
        homeworkList: [], // 初始化空数组
        publishedClassesMap: {}, // 存储作业ID到班级名称的映射
        loading: false, // 加载状态
        homeworkClasses: [], // 作业关联的班级列表
        homeworkStudentsByClass: {}, // 按班级分组的学生数据
        editDialogVisible: false, // 编辑对话框显示状态
        createDialogVisible: false, // 新建作业对话框显示状态
        batchUploadVisible: false, // 批量上传对话框显示状态
        currentBatchHomework: {}, // 当前批量上传的作业
        studentSelectList: [], // 学生选择列表

        newHomeworkForm: {
          name: ''
        },
        publishDialogVisible: false, // 发布作业对话框显示状态
        publishForm: {
          name: '',
          selectedClassIds: []
        },
        currentHomework: {}, // 当前编辑的作业
        selectedKnowledgePoint: '', // 选中的知识点
        knowledgePoints: [], // 知识点列表
        selectedRepoId: '', // 选中的题库ID
        repoList: [], // 题库列表
        questionList: [], // 题目列表
        selectedQuestions: [], // 选中的题目
          selectAllQuestions: false, // 是否全选
        questionsLoading: false, // 题目加载状态
        courseFolders: [], // 课程题库文件夹列表
        selectedCourseFolderId: '', // 选中文件夹ID
        isPublished: false, // 作业发布状态
        classList: [], // 班级列表
        tempHomeworkId: null, // 临时存储要发布的作业ID
        submissions: [], // 存储所有提交记录
        studentStatuses: {}, // 存储学生的状态信息
        refreshTrigger: 0, // 用于触发计算属性重新计算的响应式属性
        classStats: {}, // 存储班级统计信息
        homeworkStats: {}, // 存储作业统计信息
        correctionResultVisible: false, // 控制批改结果弹窗显示
        correctionResults: [], // 存储批改结果
        studentListVisible: false, // 控制学生列表弹窗显示
        submittedStudents: [], // 存储已提交的学生列表
        currentStudent: null, // 存储当前查看的学生信息
        studentImageDialogVisible: false,
        studentImageUrl: '',
        studentImages: [], // 存储学生的多张作业图片
        currentImageIndex: 0, // 当前显示的图片索引
        imageScale: 1,
        imageOffset: { x: 0, y: 0 },
        dragging: false,
        dragStart: { x: 0, y: 0 },
        lastOffset: { x: 0, y: 0 },
        studentList: [],
        recognizing: false, // AI识别状态
        currentPage: 1,
        totalPages: 1,
        currentStudentScore: null, // Add new data property for student score
        ocrDialogVisible: false,
        fileList: [],
        answersFileList: [],
        selectedQuType: '',
        quTypeOptions: [
          { value: 1, label: '选择题', type: 'select' },
          { value: 2, label: '填空题', type: 'fill' },
          { value: 3, label: '判断题', type: 'judge' },
          { value: 4, label: '简答题', type: 'application' }
        ],
        studentSubmissions: [], // 存储当前学生的所有提交记录
        currentImageIndex: 0, // 当前查看的图片索引
        homeworkComment: '', // 整体作业评语
        inputDialogVisible: false,
        inputQuestionForm: {
          quType: '',
          content: '',
          answer: '',
          knowledge: '',
          analysis: '',
          evaluate: '',
          options: '',
          difficulty: 0.5,
          level: 2
        },
        imageHomeworkCreatorVisible: false,
        autoAddToWrongBook: true, // 默认自动添加错题到错题本
        selectedClassId: null, // 当前选中的班级ID
        classSubmissionData: {}, // 存储每个班级的提交数据
        // 上传作业图片相关数据
        uploadImageDialogVisible: false, // 上传图片弹窗显示状态
        uploadDialogTitle: '上传作业图片', // 上传弹窗标题
        currentUploadStudent: null, // 当前要上传图片的学生
        uploadFileList: [], // 上传文件列表
        uploadingImage: false // 上传图片状态
      };
    },
    computed: {
      ...mapGetters([
        'name'
      ]),
      totalHomeworks() {
        return this.homeworkList.length
      },
      showEmptyState() {
        const isEmpty = !this.questionsLoading && (!this.questionList || this.questionList.length === 0)
        console.log('showEmptyState check:', {
          questionsLoading: this.questionsLoading,
          questionList: this.questionList,
          questionListLength: this.questionList?.length,
          isEmpty: isEmpty
        })
        return isEmpty
      },
      questionTypeCount() {
        const count = {};
        if (!this.currentHomework.questions) return count;
        this.currentHomework.questions.forEach(q => {
          const type = q.quType;
          count[type] = (count[type] || 0) + 1;
        });
        return count;
      },
      totalPoints() {
        if (!this.currentHomework.questions) return 0;
        return this.currentHomework.questions.reduce((sum, q) => {
          // 支持point或score字段
          const p = Number(q.point || q.score) || 0;
          return sum + p;
        }, 0);
      },
      errorQuestionCount() {
        if (!this.correctionResults || !Array.isArray(this.correctionResults)) return 0;
        return this.correctionResults.filter(result => result.judge === 'error').length;
      },
      filteredStudents() {
        // 依赖refreshTrigger来确保计算属性能够重新计算
        this.refreshTrigger; // 这里访问refreshTrigger，让计算属性依赖它

        console.log('filteredStudents - selectedClassId:', this.selectedClassId, '类型:', typeof this.selectedClassId);
        console.log('filteredStudents - homeworkStudentsByClass:', this.homeworkStudentsByClass);
        console.log('filteredStudents - refreshTrigger:', this.refreshTrigger);

        // 如果没有选中班级，返回空数组
        if (!this.selectedClassId) {
          console.log('filteredStudents - 没有选中班级，返回空数组');
          return [];
        }

        // 根据选中的班级过滤学生
        const classStudents = this.homeworkStudentsByClass[String(this.selectedClassId)];
        console.log('filteredStudents - 找到的班级数据:', classStudents);

        let students = classStudents ? classStudents.students : [];
        console.log('filteredStudents - 原始学生列表:', students);
        console.log('filteredStudents - 学生数量:', students.length);

        // 按批改状态排序：未提交 > 未批改 > 已批改
        students = [...students].sort((a, b) => {
          const statusA = this.getSubmissionStatus(a);
          const statusB = this.getSubmissionStatus(b);

          // 定义排序优先级：未提交 > 未批改 > 已批改
          const getSortOrder = (status) => {
            switch (status.text) {
              case '未提交': return 0
              case '未批改': return 1
              case '已批改': return 2
              default: return 3
            }
          }

          const orderA = getSortOrder(statusA);
          const orderB = getSortOrder(statusB);

          // 如果状态相同，按学号排序
          if (orderA === orderB) {
            return (a.student_num || '').localeCompare(b.student_num || '');
          }

          return orderA - orderB;
        });

        console.log('filteredStudents - 排序后的学生列表:');
        students.forEach((student, index) => {
          const status = this.getSubmissionStatus(student);
          console.log(`${index + 1}. ${student.name}(${student.student_num}) - ${status.text}`);
        });

        return students;
      }
    },
    async created() {
      console.log('CourseClassHomework created with courseId:', this.courseId)
      try {
        // 先检查权限
        await this.checkPermissionAndLoadData()

        // 然后获取班级列表
        await this.fetchClassList()
      } catch (error) {
        console.error('CourseClassHomework初始化失败:', error)
        this.$message.error('组件初始化失败，请刷新页面重试')
        // 发射错误事件给父组件
        this.$emit('error', error)
      }
    },
    watch: {
      // 监听选中班级变化
      selectedClassId(newVal, oldVal) {
        console.log('selectedClassId 变化:', oldVal, '->', newVal);
        console.log('当前 homeworkStudentsByClass:', this.homeworkStudentsByClass);
        if (newVal) {
          const classStudents = this.homeworkStudentsByClass[String(newVal)];
          console.log('选中班级的学生数据:', classStudents);
          if (classStudents) {
            console.log('选中班级的学生数量:', classStudents.students.length);
          }
        }
      },
      // 监听批改结果变化，实时更新错误题目数量
      correctionResults: {
        handler(newVal) {
          if (newVal && Array.isArray(newVal)) {
            console.log('批改结果更新，错误题目数量:', this.errorQuestionCount);
          }
        },
        deep: true
      }
    },
    methods: {
      onToggleSelectAll(checked) {
        if (checked) {
          // 全选当前左侧题目列表中的所有题目ID
          this.selectedQuestions = (this.questionList || []).map(q => q.id)
        } else {
          // 取消全选
          this.selectedQuestions = []
        }
      },
      // 预加载所有作业的班级名称
      async loadPublishedClasses() {
        console.log('=== loadPublishedClasses 开始 ===')

        // 收集所有需要查询的班级ID
        const allGradeIds = new Set()

        this.homeworkList.forEach(homework => {
          if (homework.published) {
            if (homework.gradeIds && homework.gradeIds.length > 0) {
              homework.gradeIds.forEach(id => allGradeIds.add(id))
            } else if (homework.gradeId) {
              allGradeIds.add(homework.gradeId)
            } else if (homework.grade_id) {
              allGradeIds.add(homework.grade_id)
            }
          }
        })

        if (allGradeIds.size === 0) {
          console.log('没有需要查询的班级ID')
          this.setDefaultClassNames()
          return
        }

        const gradeIds = Array.from(allGradeIds)
        console.log('需要查询的班级ID:', gradeIds)

        try {
          // 使用新的API根据班级ID列表查询班级信息
          const { getGradesByIds } = await import('@/api/user')
          const res = await getGradesByIds(gradeIds)
          console.log('getGradesByIds 响应:', res)

          if (res && res.code === 1 && res.data && res.data.length > 0) {
            // 创建ID到名称的映射
            const gradeMap = {}
            res.data.forEach(grade => {
              gradeMap[grade.id] = grade.grade_name
            })

            // 为每个作业计算班级名称
            this.homeworkList.forEach(homework => {
              if (homework.published) {
                let gradeIds = []
                if (homework.gradeIds && homework.gradeIds.length > 0) {
                  gradeIds = homework.gradeIds
                } else if (homework.gradeId) {
                  gradeIds = [homework.gradeId]
                } else if (homework.grade_id) {
                  gradeIds = [homework.grade_id]
                }

                if (gradeIds.length > 0) {
                  const classNames = gradeIds.map(classId => {
                    const gradeName = gradeMap[classId]
                    return gradeName || `班级${classId}`
                  })
                  this.publishedClassesMap[homework.id] = classNames.join(', ')
                } else {
                  this.publishedClassesMap[homework.id] = '未发布'
                }
              } else {
                this.publishedClassesMap[homework.id] = '未发布'
              }
            })

            console.log('班级名称映射完成:', this.publishedClassesMap)
          } else {
            console.warn('getGradesByIds 查询失败，使用默认格式')
            this.setDefaultClassNames()
          }
        } catch (error) {
          console.error('查询班级信息失败:', error)
          this.setDefaultClassNames()
        }
      },

      // 设置默认班级名称
      setDefaultClassNames() {
        this.homeworkList.forEach(homework => {
          if (homework.published) {
            let gradeIds = []
            if (homework.gradeIds && homework.gradeIds.length > 0) {
              gradeIds = homework.gradeIds
            } else if (homework.gradeId) {
              gradeIds = [homework.gradeId]
            } else if (homework.grade_id) {
              gradeIds = [homework.grade_id]
            }

            if (gradeIds.length > 0) {
              this.publishedClassesMap[homework.id] = gradeIds.map(id => `班级${id}`).join(', ')
            } else {
              this.publishedClassesMap[homework.id] = '未发布'
            }
          } else {
            this.publishedClassesMap[homework.id] = '未发布'
          }
        })
      },

      // 权限检查及数据加载
      async checkPermissionAndLoadData() {
        console.log('=== CourseClassHomework 权限检查开始 ===')
        console.log('组件props - isTeacher:', this.isTeacher)
        console.log('组件props - courseId:', this.courseId)

        // 优先使用父组件传入的权限信息
        if (this.isTeacher) {
          console.log('✅ 使用父组件传入的教师权限，直接加载数据')
          await this.fetchHomeworkList()
          return
        }

        // 如果父组件没有传入isTeacher，则进行本地权限检查
        console.log('⚠️ 父组件未传入isTeacher，进行本地权限检查')

        // 等待一下确保localStorage数据加载完成（特别是新窗口情况）
        await new Promise(resolve => setTimeout(resolve, 100))

        // 从JWT token中获取用户角色信息
        const userInfoStr = localStorage.getItem('userInfo')
        const rolesStr = localStorage.getItem('roles')
        let userInfo = null
        let roleId = null

        console.log('localStorage userInfo:', userInfoStr)
        console.log('localStorage roles:', rolesStr)

        try {
          userInfo = JSON.parse(userInfoStr)
          roleId = userInfo && userInfo.roleId
          console.log('解析后的userInfo:', userInfo)
          console.log('解析后的roleId:', roleId)
        } catch (error) {
          console.error('解析用户信息失败:', error)
        }

        // 如果从userInfo中获取不到roleId，尝试从roles字段获取
        if (!roleId) {
          console.log('从roles字段获取角色:', rolesStr)
          if (rolesStr === 'teacher' || rolesStr === 'mteacher') {
            console.log('✅ 从roles字段确认教师权限')
            await this.fetchHomeworkList()
            return
          }
        }

        // 检查是否为教师角色 (roleId === 2 或 4)
        if (roleId && (roleId === 2 || roleId === 4)) {
          console.log('✅ 从userInfo确认教师权限，roleId:', roleId)
          await this.fetchHomeworkList()
          return
        }

        // 所有权限检查都失败
        console.error('❌ 权限检查失败')
        console.error('roleId:', roleId)
        console.error('roles:', rolesStr)
        console.error('isTeacher:', this.isTeacher)
        console.error('userInfo:', userInfo)

        this.$message.error('您没有权限访问此页面')
        return this.$router.push('/404')
      },

      // 获取作业列表
      async fetchHomeworkList() {
        console.log('Fetching homework list for course:', this.courseId)
        this.loading = true
        try {
          let homeworkList = []
          let imageHomeworkList = []

          // 如果有课程ID，优先根据用户ID和课程ID获取作业
          if (this.courseId) {
            console.log('Fetching homework by course ID:', this.courseId)
            const courseId = parseInt(this.courseId)

            // 验证courseId是否为有效数字
            if (isNaN(courseId) || courseId <= 0) {
              console.error('Invalid courseId:', this.courseId)
              this.$message.error('无效的课程ID')
              return
            }

            // 获取当前用户ID
            let userId = null
            try {
              const userInfoStr = window.localStorage.getItem('userInfo') || '{}'
              const parsed = JSON.parse(userInfoStr)
              userId = parsed && parsed.id != null ? parseInt(parsed.id) : null
              console.log('Current user ID:', userId)
            } catch (e) {
              console.warn('Failed to parse user info:', e)
            }

            let res = null
            if (userId && userId > 0) {
              // 使用新的API：根据用户ID和课程ID获取作业
              console.log('Using new API: getHomeworkListByUserIdAndCourseId')
              res = await getHomeworkListByUserIdAndCourseId(userId, courseId)
            } else {
              // 回退到原来的API：仅根据课程ID获取作业
              console.log('Using fallback API: getHomeworkListByCourseId')
              res = await getHomeworkListByCourseId(courseId)
            }

            console.log('Course homework list response:', res)
            console.log('Response code:', res.code)
            console.log('Response data:', res.data)

            if (res && res.code === 1 && res.data && Array.isArray(res.data)) {
              homeworkList = res.data.map(homework => {
                // 确保gradeId存在
                const gradeId = homework.gradeId || homework.grade_id
                console.log('Processing course homework:', homework, 'gradeId:', gradeId)
                return {
                  ...homework,
                  gradeId: gradeId,
                  isImageType: false // 标记为非图片作业
                }
              })
              console.log('Processed course homework list:', homeworkList)
            } else {
              console.warn('No valid homework data received for course:', courseId)
              console.warn('Response details:', res)
              if (res && res.msg) {
                this.$message.warning(`获取作业列表失败: ${res.msg}`)
              }
            }
          } else {
            // 如果没有课程ID，获取所有作业（保持原有逻辑）
            console.log('No course ID, fetching all homework')
            const res = await getHomeworkList()
            console.log('All homework list response:', res)

            if (res && res.data) {
              homeworkList = res.data.map(homework => {
                // 确保gradeId存在
                const gradeId = homework.gradeId || homework.grade_id
                console.log('Processing homework:', homework, 'gradeId:', gradeId)
                return {
                  ...homework,
                  gradeId: gradeId,
                  isImageType: false // 标记为非图片作业
                }
              })
              console.log('Processed homework list:', homeworkList)
            }
          }

          // 获取图片作业列表（图片作业暂时不按课程筛选，因为ImageHomework表可能没有course_id字段）
          try {
            const imageRes = await getImageHomeworkList()
            console.log('Image homework list response:', imageRes)

            if (imageRes && imageRes.code === 1 && imageRes.data && Array.isArray(imageRes.data)) {
              imageHomeworkList = imageRes.data.map(homework => ({
                ...homework,
                isImageType: true // 标记为图片作业
              }))

              // 如果有课程ID，需要过滤图片作业（这里可以根据实际需求调整）
              if (this.courseId) {
                // 暂时保留所有图片作业，或者可以根据创建人等信息进行筛选
                console.log('Keeping all image homework for now')
              }
            } else {
              console.warn('No valid image homework data received')
            }
          } catch (imageError) {
            console.error('获取图片作业列表失败:', imageError)
            // 图片作业获取失败不影响普通作业的显示
          }

          // 合并两种作业列表
          this.homeworkList = [...homeworkList, ...imageHomeworkList]
          // 预加载班级名称
          await this.loadPublishedClasses()

          // 如果班级名称加载失败，尝试重试
          if (Object.keys(this.publishedClassesMap).length === 0 && this.homeworkList.length > 0) {
            console.log('班级名称加载失败，尝试重试...')
            setTimeout(() => {
              this.loadPublishedClasses()
            }, 1000)
          }

          // 按当前登录用户ID筛选（与后端返回的 createPerson 对比）
          try {
            const userInfoStr = window.localStorage.getItem('userInfo') || '{}'
            const parsed = JSON.parse(userInfoStr)
            const myId = parsed && parsed.id != null ? String(parsed.id) : ''
            if (myId && this.homeworkList && this.homeworkList.length > 0) {
              this.homeworkList = this.homeworkList.filter(hw => {
                const createPerson = hw.createPerson || hw.creator
                return createPerson && String(createPerson) === myId
              })
            }
          } catch (e) {
            console.warn('用户信息解析失败，跳过作业筛选:', e)
            // 若解析失败则不做筛选
          }

          console.log('Final homework list:', this.homeworkList)
        } catch (error) {
          console.error('获取作业列表失败', error)
          this.$message.error('获取作业列表失败，请重试')
        } finally {
          this.loading = false
        }
      },

      // 测试按钮（示例）
      // test() {
      //   console.log('Test button clicked');
      //   axios.get('http://localhost:8080/api/homework/list')
      //     .then(res => {
      //       console.log('Test request response:', res);
      //       this.$message.success('测试请求成功');
      //     })
      //     .catch(err => {
      //       console.error('Test request error:', err);
      //       this.$message.error('测试请求失败');
      //     });
      // },

      // 创建作业对话框
      showCreateDialog() {
        this.createDialogVisible = true
      },

      // 处理创建作业对话框关闭
      async handleCreateDialogClose() {
        // 对话框关闭后查询作业列表
        await this.fetchHomeworkList()
      },

      // 处理新建作业
      async handleCreateHomework() {
        if (!this.newHomeworkForm.name.trim()) {
          this.$message.warning('作业名称不能为空')
          return
        }

        let loadingInstance = null; // 在try块外声明loadingInstance
        try {
          loadingInstance = this.$loading({
            lock: true,
            text: '正在创建作业...',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          // 创建作业，包含课程ID
          // 从localStorage获取当前用户ID
          let currentUserId = 1; // 默认值
          try {
            const userInfoStr = window.localStorage.getItem('userInfo') || '{}'
            const parsed = JSON.parse(userInfoStr)
            if (parsed && parsed.id) {
              currentUserId = parsed.id
            }
          } catch (e) {
            console.warn('获取用户信息失败，使用默认用户ID:', e)
          }

          const homeworkData = {
            name: this.newHomeworkForm.name,
            createPerson: currentUserId,
            courseId: parseInt(this.courseId) // 添加课程ID，确保是数字类型
          }
          console.log('Creating homework with data:', homeworkData)
          const response = await createHomework(homeworkData)
          console.log('Create homework response:', response)

          // 检查后端返回的code字段
          if (response.code === 1) {
            loadingInstance.close()
            this.$message.success('作业创建成功')
            // 重置表单
            this.newHomeworkForm = {
              name: ''
            }
            // 关闭对话框，不立即查询列表
            this.createDialogVisible = false
          } else {
            // code不为1表示失败
            loadingInstance.close()
            this.$message.error(response.msg || '作业创建失败')
          }
        } catch (error) {
          console.error('创建作业失败', error)
          // 确保关闭loading
          if (loadingInstance) {
            loadingInstance.close()
          }
          this.$message.error('创建作业失败，请重试')
        }
      },

      // 编辑作业
      async editHomework(homework) {
        this.currentHomework = JSON.parse(JSON.stringify(homework))

        // 判断是否是图片作业
        if (homework.isImageType) {
          // 对于图片作业，打开图片作业编辑器
          console.log('正在编辑图片作业:', homework)

          if (homework.imageUrl) {
            // 使用自建图片作业组件进行编辑
            this.imageHomeworkCreatorVisible = true

            // 下一帧等待组件加载完成
            this.$nextTick(() => {
              // 通过引用获取ImageHomeworkCreator组件实例
              const imageHomeworkCreator = this.$refs.imageHomeworkCreator
              if (imageHomeworkCreator) {
                // 调用组件的编辑方法
                imageHomeworkCreator.editHomework(homework)
              } else {
                this.$message.error('无法获取图片作业编辑器组件')
              }
            })
          } else {
            this.$message.warning('该图片作业没有关联的图片，无法编辑')
          }
          return
        }

        // 普通作业编辑逻辑
        this.editDialogVisible = true

        try {
          // 1. 获取知识点内容
          const params = {
            suboptions: this.testdata[0].suboptions,
            textbookOptions: this.testdata[0].textbookOptions,
            gradeoptions: this.testdata[0].gradeoptions
          }

          console.log('Fetching knowledge content with params:', params)
          const res = await getKnowledgeContent(params)

          console.log('Knowledge content response:', res)
          if (res && res.data) {
            this.knowledgePoints = res.data
          } else {
            console.warn('No knowledge points data received')
          }

          // 2. 获取题库列表
          const repoRes = await fetchPaging()
          console.log('Repo list response:', repoRes)
          if (repoRes && repoRes.data) {
            this.repoList = repoRes.data
            console.log('Loaded repo list:', this.repoList)
          }

          // 3. 获取当前作业的题目详细信息（从关联表查询）
          console.log('Fetching question details for homework:', homework.id)
          const questionDetailsRes = await getQuestionDetailsByHomeworkId(homework.id)
          console.log('Question details response:', questionDetailsRes)
          console.log('Question details response data:', questionDetailsRes?.data)
          console.log('Question details response data length:', questionDetailsRes?.data?.length)

          if (questionDetailsRes && questionDetailsRes.data && questionDetailsRes.data.length > 0) {
            // 将题目详细信息转换为作业题目格式
            const questions = questionDetailsRes.data.map(question => ({
              id: question.questionId,
              content: question.content,
              quType: question.quType,
              answer: question.answer,
              analysis: question.analysis,
              difficulty: question.difficulty,
              point: question.point || 10,
              knowledge: question.knowledge,
              image: question.image,
              optionsStr: question.optionsStr,
              type: question.type,
              level: question.level,
              url: question.url,
              createTime: question.createTime,
              repoTitle: question.repoTitle,
              repoId: question.repoId
            }))

            this.$set(this.currentHomework, 'questions', questions)
            console.log('Current homework questions updated:', this.currentHomework.questions)

            // 4. 不再将当前作业题目填充到左侧题目列表，避免左侧显示当前作业的题目
            // 保持 questionList 由查询/OCR/手动输入填充
            console.log('Skip injecting current homework questions into left list')
          } else {
            console.warn('No question details received')
            this.$set(this.currentHomework, 'questions', [])
            // 不主动重置左侧题目列表，由用户查询/OCR/手动输入决定
            console.log('Keep left question list unchanged')
          }
        } catch (error) {
          console.error('Error details:', {
            message: error.message,
            response: error.response,
            config: error.config
          })
          this.$message.error('获取数据失败: ' + (error.response?.data?.message || error.message))
        }
      },

      // 处理对话框关闭
      handleClose(done) {
        this.$confirm('确认关闭？未保存的内容将会丢失')
          .then(_ => {
            this.currentHomework = {}
            done()
          })
          .catch(_ => { })
      },

      // 保存作业
      async saveHomework() {
        if (!this.currentHomework.questions || this.currentHomework.questions.length === 0) {
          this.$message.warning('请先添加题目')
          return
        }

        try {
          const loadingInstance = this.$loading({
            lock: true,
            text: '正在保存作业...',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          // 在保存关联前，先为手动输入/OCR新增的题目解析真实ID
          // 若题目id不是正整数或看起来是临时ID，则通过内容反查真实questionId
          const resolvedQuestions = []
          for (const q of (this.currentHomework.questions || [])) {
            let idNum = Number(q.id)
            if (!Number.isInteger(idNum) || idNum <= 0 || idNum > 1000000) {
              try {
                const byContent = await quDetailbyContent(q.content)
                if (byContent && byContent.data) {
                  if (Array.isArray(byContent.data) && byContent.data.length > 0 && (byContent.data[0].id || byContent.data[0].questionId)) {
                    idNum = Number(byContent.data[0].id || byContent.data[0].questionId)
                  } else if (byContent.data.id || byContent.data.questionId) {
                    idNum = Number(byContent.data.id || byContent.data.questionId)
                  }
                }
              } catch (e) {
                console.warn('按内容反查题目ID失败，将跳过该题关联：', q.content, e)
              }
            }
            resolvedQuestions.push({ ...q, id: idNum })
          }

          // 构建符合后端SpecificHomework实体类要求的数据格式
          const questionsData = resolvedQuestions
            .map(question => ({
              questionId: Number(question.id),
              content: question.content || question.stem || '',
              quType: Number(question.quType) || 1,
              homeworkId: Number(this.currentHomework.id),
              gradeId: Number(question.gradeId) || 1,
              point: Number(question.point || question.score) || 10,
              answer: question.answer || ''
            }))
            .filter(item => {
              // 严格过滤：只保留有效的数据库ID（通常小于1000000）
              const id = item.questionId;
              return Number.isInteger(id) && id > 0 && id < 1000000;
            })

          if (questionsData.length === 0) {
            this.$message.error('没有可保存的题目（缺少有效题目ID）')
            loadingInstance.close()
            return
          }

          console.log('Raw questions before mapping:', this.currentHomework.questions.map(q => ({ id: q.id, content: q.content?.substring(0, 20) })))
          console.log('Sending questions data:', questionsData)
          console.log('Sending questions data details:', JSON.stringify(questionsData, null, 2))

          // 调用后端API保存作业题目
          const response = await saveSpecificHomework(this.currentHomework.id, questionsData)
          console.log('Save homework response:', response)

          loadingInstance.close()

          // 检查后端返回的code字段
          if (response.code === 1) {
            this.$message.success('保存成功')

            // 保存成功后，立即从后端拉取最新的题目详情，确保预览与数据库一致
            try {
              const refreshed = await getQuestionDetailsByHomeworkId(this.currentHomework.id)
              console.log('Refreshed question details after save:', refreshed)
              if (refreshed && Array.isArray(refreshed.data)) {
                const questions = refreshed.data.map(question => ({
                  id: question.questionId,
                  content: question.content,
                  quType: question.quType,
                  point: Number(question.point) || 10,
                  answer: question.answer || '',
                  analysis: question.analysis || '',
                  knowledge: question.knowledge || '',
                  difficulty: question.difficulty,
                  optionsStr: question.optionsStr || question.options || '',
                  type: question.type,
                  level: question.level,
                  url: question.url,
                  createTime: question.createTime,
                  repoTitle: question.repoTitle,
                  repoId: question.repoId
                }))
                this.$set(this.currentHomework, 'questions', questions)
              }
            } catch (e) {
              console.warn('刷新题目详情失败（已忽略）：', e)
            }

            // 关闭编辑弹窗
            this.editDialogVisible = false

            // 同步更新作业列表中的题目数据
            const homeworkIndex = this.homeworkList.findIndex(h => h.id === this.currentHomework.id)
            if (homeworkIndex !== -1) {
              this.homeworkList[homeworkIndex].questions = this.currentHomework.questions
            }
          } else {
            // code不为1表示失败
            this.$message.error(response.msg || '保存失败')
          }
        } catch (error) {
          console.error('保存作业失败', error)
          this.$message.error('保存失败，请重试')
        }
      },

      // 获取班级列表
      async fetchClassList() {
        console.log('=== fetchClassList 开始 ===')
        console.log('courseId:', this.courseId)
        try {
          let gradeIds = []

          // 如果有课程ID，获取课程关联的班级ID列表
          if (this.courseId) {
            console.log('使用 getGradesByCourseId API 获取班级ID')
            const { getGradesByCourseId } = await import('@/api/course')
            const res = await getGradesByCourseId(this.courseId)
            console.log('getGradesByCourseId 响应:', res)

            if (res && res.code === 1 && res.data) {
              gradeIds = res.data.map(item => item.gradeId)
              console.log('获取课程班级ID列表:', gradeIds)
            } else {
              console.warn('获取课程班级ID列表失败:', res)
              gradeIds = []
            }
          } else {
            console.log('使用 classPaging API 获取班级ID')
            // 如果没有课程ID，获取所有班级ID列表
            const res = await classPaging()
            console.log('classPaging 响应:', res)

            if (res && res.data) {
              gradeIds = res.data.records.map(item => item.id)
              console.log('获取所有班级ID列表:', gradeIds)
            }
          }

          // 使用新的API根据班级ID列表查询班级详细信息
          if (gradeIds.length > 0) {
            console.log('使用 getGradesByIds API 查询班级详细信息')
            const { getGradesByIds } = await import('@/api/user')
            const res = await getGradesByIds(gradeIds)
            console.log('getGradesByIds 响应:', res)

            if (res && res.code === 1 && res.data) {
              // 统一数据格式，确保包含所有必要字段
              this.classList = res.data.map(item => ({
                id: item.id,
                gradeId: item.id,
                grade_id: item.id,
                grade_name: item.grade_name,
                gradeName: item.grade_name,
                name: item.grade_name,
                code: item.code
              }))
              console.log('获取班级详细信息成功:', this.classList)
            } else {
              console.warn('getGradesByIds 查询失败，使用默认格式')
              this.classList = gradeIds.map(id => ({
                id: id,
                gradeId: id,
                grade_id: id,
                grade_name: null,
                gradeName: null,
                name: null,
                code: null
              }))
            }
          } else {
            console.log('没有班级ID，设置空列表')
            this.classList = []
          }

          console.log('=== fetchClassList 完成 ===')
        } catch (error) {
          console.error('获取班级列表失败', error)
          this.$message.error('获取班级列表失败')
          this.classList = []
        }
      },

      // 发布作业
      async publishHomework(homeworkId) {
        // 获取当前作业项
        const homework = this.homeworkList.find(h => h.id === homeworkId)
        console.log('Found homework:', homework)

        if (!homework) {
          this.$message.error('未找到要发布的作业')
          return
        }

        // 检查是否是图片作业
        if (!homework.isImageType) {
          // 普通作业需要检查题目 - 从关联表获取最新数据
          try {
            console.log('Fetching latest question details for homework:', homeworkId)
            const questionDetailsRes = await getQuestionDetailsByHomeworkId(homeworkId)
            console.log('Latest question details response:', questionDetailsRes)

            if (!questionDetailsRes || !questionDetailsRes.data || questionDetailsRes.data.length === 0) {
              this.$message.warning('该作业没有题目，请先添加题目')
              return
            }

            // 更新本地作业数据中的题目信息
            const questions = questionDetailsRes.data.map(question => ({
              id: question.questionId,
              content: question.content,
              quType: question.quType,
              answer: question.answer,
              analysis: question.analysis,
              difficulty: question.difficulty,
              point: question.point || 10,
              knowledge: question.knowledge,
              image: question.image,
              optionsStr: question.optionsStr,
              type: question.type,
              level: question.level,
              url: question.url,
              createTime: question.createTime,
              repoTitle: question.repoTitle,
              repoId: question.repoId
            }))

            homework.questions = questions
            console.log('Updated homework questions:', homework.questions)
          } catch (error) {
            console.error('获取作业题目失败:', error)
            this.$message.error('获取作业题目失败，请重试')
            return
          }
        }

        // 预填充：获取当前作业已发布班级，做为初始选中，便于去掉班级
        try {
          const publishedRes = await getHomeworkGrades(homeworkId)
          const preselected = (publishedRes && publishedRes.data) || []
          this.publishForm = {
            name: homework.name,
            selectedClassIds: Array.isArray(preselected) ? preselected : []
          }
        } catch (e) {
          this.publishForm = {
            name: homework.name,
            selectedClassIds: []
          }
        }
        this.tempHomeworkId = homeworkId

        // 获取班级列表并显示发布对话框
        await this.fetchClassList()
        this.publishDialogVisible = true
      },

      // 处理发布作业
      async handlePublishHomework() {
        if (this.publishForm.selectedClassIds.length === 0) {
          this.$message.warning('请至少选择一个班级')
          return
        }

        try {
          const confirm = await this.$confirm('确定要发布该作业吗？发布后学生将可以看到作业内容。', '发布确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(() => false)

          if (!confirm) return

          const loadingInstance = this.$loading({
            lock: true,
            text: '正在发布作业...',
            background: 'rgba(0, 0, 0, 0.7)'
          })

                  try {
            // 获取当前作业项
            const homework = this.homeworkList.find(h => h.id === this.tempHomeworkId)

            if (homework.isImageType) {
              // 图片作业发布逻辑
              await publishImageHomework(this.tempHomeworkId)
            } else {
              // 普通作业发布逻辑：统一走批量接口，后端已实现“先清空后新增”的集合同步
              const publishData = {
                name: homework.name,
                gradeIds: this.publishForm.selectedClassIds,
                subject: homework.subject || '数学'
              }
              if (homework.questions && homework.questions.length > 0) {
                publishData.count = homework.questions.length
              }
              console.log('Publishing homework (sync grades):', this.publishForm.selectedClassIds, publishData)
              const response = await publishHomeworkMultiple(this.tempHomeworkId, publishData)
              if (response.code !== 1) {
                throw new Error(response.msg || '发布失败')
              }
            }

            loadingInstance.close()
            this.$message.success('发布成功')
            this.publishDialogVisible = false
            await this.fetchHomeworkList()
          } catch (error) {
            loadingInstance.close()
            throw error
          }
        } catch (error) {
          console.error('发布作业失败', error)
          this.$message.error('发布失败，请重试')
        }
      },

      // 删除作业
      async deleteHomework(homeworkId) {
        const confirm = await this.$confirm('确定要删除该作业吗？', '删除确认', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(() => false)

        if (confirm) {
          try {
            // 获取要删除的作业项
            const homework = this.homeworkList.find(h => h.id === homeworkId)

            if (!homework) {
              this.$message.error('未找到要删除的作业')
              return
            }

            if (homework.isImageType) {
              // 使用图片作业删除API
              await deleteImageHomework(homeworkId)
            } else {
              // 使用普通作业删除API
            await deleteHomework(homeworkId)
            }

            await this.fetchHomeworkList()
            this.$message.success('作业删除成功')
          } catch (error) {
            this.$message.error('作业删除失败，请重试')
          }
        }
      },

      // 获取知识点列表
      async fetchKnowledgePoints() {
        try {
          // const res = await axios.get('http://localhost:8080/api/knowledge-points');
          const res = await getKnowledge()
          this.knowledgePoints = res.data || []
        } catch (error) {
          console.error('获取知识点列表失败', error)
          this.$message.error('获取知识点列表失败')
        }
      },

      // 搜索题目
      async searchQuestions() {
        if (!this.selectedKnowledgePoint && !this.selectedRepoId) {
          this.$message.warning('请先选择知识点或题库')
          return
        }

        this.questionsLoading = true
        try {
          let res
          if (this.selectedRepoId) {
            // 按题库筛选
            console.log('Searching questions by repo ID:', this.selectedRepoId)
            res = await getQuestionsByRepoId(this.selectedRepoId)
          } else if (this.selectedKnowledgePoint) {
            // 按知识点筛选
            console.log('Searching questions by knowledge:', this.selectedKnowledgePoint)
            res = await getQuestionsByKnowledge({
              knowledge: this.selectedKnowledgePoint
            })
          }

          console.log('Questions response:', res)
          if (res && res.data) {
            // 将搜索到的题目添加到左侧题目列表中（而不是替换）
            const newQuestions = res.data.map(q => ({
              ...q,
              point: q.point || 10 // 确保有分数字段
            }))
            this.questionList = [...this.questionList, ...newQuestions]
            console.log('Added questions to list:', this.questionList)
            this.$message.success(`已添加 ${newQuestions.length} 道题目到题目列表`)
          }
        } catch (error) {
          console.error('获取题目列表失败', error)
          this.$message.error('获取题目列表失败，请重试')
        } finally {
          this.questionsLoading = false
        }
      },

      // 从课程题库加载题目
      async loadCourseQuestions() {
        if (!this.courseId) {
          this.$message.warning('无法获取课程ID')
          return
        }

        this.questionsLoading = true
        try {
          console.log('Loading questions from course question banks, courseId:', this.courseId)
          const res = await getCourseQuestions(this.courseId)

          console.log('Course questions response:', res)
          if (res && res.data) {
            // 将课程题库中的题目添加到左侧题目列表中
            const newQuestions = res.data.map(q => ({
              ...q,
              point: q.point || 10, // 确保有分数字段
              content: q.title || q.content, // 统一内容字段
              quType: q.type || q.quType // 统一题型字段
            }))
            this.questionList = [...this.questionList, ...newQuestions]
            console.log('Added course questions to list:', this.questionList)
            this.$message.success(`已从课程题库添加 ${newQuestions.length} 道题目`)
          } else {
            this.$message.info('该课程暂无题库题目')
          }
        } catch (error) {
          console.error('获取课程题库题目失败', error)
          this.$message.error('获取课程题库题目失败，请重试')
        } finally {
          this.questionsLoading = false
        }
      },

      // 加载课程题库文件夹
      async loadCourseFolders() {
        if (!this.courseId) {
          this.$message.warning('无法获取课程ID')
          return
        }
        this.questionsLoading = true
        try {
          const banksRes = await getQuestionBanksByCourseId(this.courseId)
          const banks = (banksRes && banksRes.data) || []
          if (!banks.length) {
            this.courseFolders = []
            this.$message.info('该课程暂无题库')
            return
          }
          const allFolders = []
          for (const b of banks) {
            const fRes = await getQuestionBankFolderTree(b.id)
            const folders = (fRes && fRes.data) || []
            const stack = Array.isArray(folders) ? [...folders] : []
            while (stack.length) {
              const node = stack.pop()
              allFolders.push({
                id: node.id,
                name: node.name,
                bankId: b.id,
                bankName: b.name || b.title || `题库${b.id}`,
                fullName: `${b.name || b.title || '题库'} / ${node.name}`
              })
              if (node.children && node.children.length) stack.push(...node.children)
            }
          }
          this.courseFolders = allFolders.sort((a, b) => a.fullName.localeCompare(b.fullName))
          this.$message.success(`已加载 ${this.courseFolders.length} 个文件夹`)
        } catch (e) {
          console.error('加载课程题库文件夹失败', e)
          this.$message.error('加载课程题库文件夹失败')
        } finally {
          this.questionsLoading = false
        }
      },

      // 选择文件夹后加载题目
      async loadQuestionsBySelectedFolder(folderId) {
        if (!folderId) return
        this.questionsLoading = true
        try {
          const res = await getFolderQuestions(folderId)
          const list = (res && res.data) || []
          const mapped = list.map(q => ({
            id: q.id || q.questionId,
            repoId: q.bankId,
            bankName: q.bankName,
            folderName: q.folderName,
            content: q.title || q.questionContent || q.content,
            quType: q.type || q.questionType,
            difficulty: q.difficulty || q.questionDifficulty,
            point: q.point || 10
          }))
          // 替换为该文件夹对应题目，避免重复叠加
          this.questionList = mapped
          // 清空之前的选中项，避免交叉选择
          this.selectedQuestions = []
          this.$message.success(`已加载该文件夹 ${mapped.length} 道题目`)
        } catch (e) {
          console.error('按文件夹加载题目失败', e)
          this.$message.error('按文件夹加载题目失败')
        } finally {
          this.questionsLoading = false
        }
      },

      // 下拉展开时懒加载课程题库文件夹
      async onCourseFolderDropdownVisible(visible) {
        if (!visible) return
        if (this.courseFolders && this.courseFolders.length) return
        await this.loadCourseFolders()
      },

      // 重置题目
      async resetQuestions() {
        this.questionsLoading = true
        try {
          // 清空题目列表
          this.questionList = []
          this.selectedKnowledgePoint = ''
          this.selectedRepoId = ''
          this.selectedQuestions = []
          this.$message.success('题目列表已清空')
        } catch (error) {
          this.$message.error('重置题目列表失败')
        } finally {
          this.questionsLoading = false
        }
      },

      // 添加选中的题目
      async addSelectedQuestions() {
        const selectedQuestionDetails = this.questionList.filter(q =>
          this.selectedQuestions.includes(q.id)
        )

        // 如果currentHomework.questions不存在，初始化为空数组
        if (!this.currentHomework.questions) {
          this.$set(this.currentHomework, 'questions', [])
        }

        // 为每个选中的题目获取详细信息（包括答案）
        const questionsWithDetails = []
        for (const question of selectedQuestionDetails) {
          try {
            // 如果题目已经有答案字段，直接使用
            if (question.answer) {
              questionsWithDetails.push(question)
            } else {
              // 否则尝试获取题目详情
              const detailResponse = await getQuestionDetail(question.id)
              if (detailResponse && detailResponse.data) {
                questionsWithDetails.push({
                  ...question,
                  answer: detailResponse.data.answer || ''
                })
              } else {
                // 如果获取详情失败，使用原题目数据
                questionsWithDetails.push({
                  ...question,
                  answer: ''
                })
              }
            }
          } catch (error) {
            console.warn(`获取题目 ${question.id} 详情失败:`, error)
            // 如果获取详情失败，使用原题目数据
            questionsWithDetails.push({
              ...question,
              answer: ''
            })
          }
        }

        // 添加选中的题目到作业中
        this.currentHomework.questions.push(...questionsWithDetails)

        // 清空选中状态
        this.selectedQuestions = []

        this.$message.success(`已添加 ${questionsWithDetails.length} 道题目`)
      },

      // 移除题目
      removeQuestion(index) {
        this.$confirm('确定要移除这道题目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.currentHomework.questions.splice(index, 1)
          this.$message.success('题目已移除')
        }).catch(() => { })
      },

      // 获取题目类型描述
      getQuestionType(type) {
        const typeMap = {
          1: '选择题',
          2: '判断题',
          3: '填空题',
          4: '计算题',
          5: '解答题'
        }
        return typeMap[Number(type)] || '未知类型'
      },

      // 获取题库名称
      getRepoName(repoId) {
        if (!repoId || !this.repoList || this.repoList.length === 0) {
          return '未知题库'
        }

        const repo = this.repoList.find(r => r.id === repoId)
        if (repo) {
          return `${repo.title}(${repoId})`
        }

        return `题库${repoId}`
      },

      async handleHomeworkNameClick(homework) {
          const loadingInstance = this.$loading({
            lock: true,
            text: '正在加载学生信息...',
            background: 'rgba(0, 0, 0, 0.7)'
          });

        try {
          // 使用新的API获取作业班级和学生信息
          console.log('正在获取作业ID为', homework.id, '的班级和学生信息...');
          const response = await getHomeworkClassesAndStudents(homework.id);
          console.log('API响应:', response);

          if (response && response.data) {
            this.homeworkClasses = response.data.classes || [];
            this.homeworkStudentsByClass = response.data.studentsByClass || {};
            console.log('解析后的班级数据:', this.homeworkClasses);
            console.log('解析后的学生数据:', this.homeworkStudentsByClass);

            // 使用新的t_homework_submit表加载学生提交状态数据
            this.submissions = [];
            this.studentStatuses = {};
            console.log('开始加载学生提交状态数据...');

            // 为每个学生检查提交状态
            for (const classData of Object.values(this.homeworkStudentsByClass)) {
              if (classData.students) {
                for (const student of classData.students) {
                  // 解析可用的学生ID
                  const studentIdToUse = this.resolveStudentId(student);

                  try {
                    console.log('学生对象结构:', student);
                    console.log('学生ID字段候选:', {
                      id: student.id,
                      student_id: student.student_id,
                      studentId: student.studentId,
                      userId: student.userId,
                      student_num: student.student_num,
                      studentNum: student.studentNum
                    });
                    // 检查学生对象的所有字段，寻找正确的学生ID
                    console.log('学生对象所有字段:', Object.keys(student));
                    console.log('学生对象完整数据:', JSON.stringify(student, null, 2));

                    console.log('使用解析后的studentId:', studentIdToUse);
                    console.log('最终使用的学生ID:', studentIdToUse);
                    const response = await getSubmitByStudentIdAndHomeworkId(parseInt(studentIdToUse), parseInt(homework.id));
                    if (response.code === 1 && response.data) {
                      // 有提交记录
                      this.submissions.push({
                        homeworkId: homework.id,
                        studentId: studentIdToUse,
                        submitted: true,
                        status: response.data.submitStatus,
                        point: response.data.totalScore || null,
                        submitTime: response.data.submitTime
                      });

                      // 检查批改状态
                      try {
                        const detailsResponse = await getSubmitDetails(response.data.submitId);
                        if (detailsResponse.code === 1 && detailsResponse.data && detailsResponse.data.length > 0) {
                          // 有批改详情，检查是否有实际的批改内容
                          const hasGrading = detailsResponse.data.some(detail =>
                            detail.isCorrect !== null ||
                            (detail.teacherComment && detail.teacherComment.trim() !== '') ||
                            (detail.studentScore && detail.studentScore > 0)
                          );
                          this.studentStatuses[studentIdToUse] = hasGrading
                            ? { type: 'success', text: '已批改' }
                            : { type: 'warning', text: '未批改' };
                        } else {
                          // 没有批改详情，说明已提交但未批改
                          this.studentStatuses[studentIdToUse] = { type: 'warning', text: '未批改' };
                        }
                      } catch (error) {
                        console.error(`检查学生${studentIdToUse}批改状态失败:`, error);
                        this.studentStatuses[studentIdToUse] = { type: 'info', text: '已提交' };
                      }
                    } else {
                      // 没有提交记录
                      this.submissions.push({
                        homeworkId: homework.id,
                        studentId: studentIdToUse,
                        submitted: false,
                        status: null,
                        point: null,
                        submitTime: null
                      });
                      this.studentStatuses[studentIdToUse] = { type: 'danger', text: '未提交' };
                    }
                  } catch (error) {
                    console.warn(`获取学生${studentIdToUse}提交状态失败:`, error);
                    // 出错时也添加未提交记录
                    this.submissions.push({
                      homeworkId: homework.id,
                      studentId: studentIdToUse,
                      submitted: false,
                      status: null,
                      point: null,
                      submitTime: null
                    });
                    this.studentStatuses[studentIdToUse] = { type: 'danger', text: '未提交' };
                  }
                }
              }
            }
            console.log('学生提交状态数据:', this.submissions);
            console.log('学生状态数据:', this.studentStatuses);

            // 计算总学生数
          let totalStudents = 0;
            Object.values(this.homeworkStudentsByClass).forEach(classData => {
              if (classData.students) {
                totalStudents += classData.students.length;
              }
            });

          this.currentHomework = {
            ...homework,
              submissionCount: 0, // 这里可以后续添加提交统计
            totalStudents: totalStudents
          };

          // 默认选择第一个班级，如果没有班级则设为null
          this.selectedClassId = this.homeworkClasses.length > 0 ? this.homeworkClasses[0].id : null;

            console.log('作业班级信息:', this.homeworkClasses);
            console.log('作业学生信息:', this.homeworkStudentsByClass);

            // 调试：检查数据结构匹配
            console.log('班级列表中的ID:', this.homeworkClasses.map(c => ({ id: c.id, type: typeof c.id })));
            console.log('学生数据中的键:', Object.keys(this.homeworkStudentsByClass));

            // 检查每个班级是否有对应的学生数据
            this.homeworkClasses.forEach(classInfo => {
              const classId = String(classInfo.id);
              const hasStudents = this.homeworkStudentsByClass.hasOwnProperty(classId);
              console.log(`班级 ${classInfo.grade_name}(${classId}) 是否有学生数据:`, hasStudents);
              if (hasStudents) {
                console.log(`班级 ${classId} 的学生数量:`, this.homeworkStudentsByClass[classId].students.length);
              }
            });

          loadingInstance.close();
          this.studentListVisible = true;
          } else {
            throw new Error('获取作业班级和学生信息失败');
          }
        } catch (error) {
          console.error('获取作业班级和学生信息失败:', error);
          console.error('错误详情:', {
            message: error.message,
            response: error.response,
            status: error.response?.status,
            data: error.response?.data
          });

          let errorMessage = '获取学生列表失败';
          if (error.response?.status === 500) {
            errorMessage = '服务器内部错误，可能是数据库表不存在';
          } else if (error.response?.status === 404) {
            errorMessage = 'API接口不存在';
          } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.$message.error(errorMessage);
          loadingInstance.close();
        }
      },

      // 选择班级
      selectClass(classId) {
        console.log('selectClass - 点击班级ID:', classId, '类型:', typeof classId);
        console.log('selectClass - 当前选中班级:', this.selectedClassId);

        this.selectedClassId = this.selectedClassId === classId ? null : classId;

        console.log('selectClass - 选择后班级ID:', this.selectedClassId);

        // 立即检查过滤后的学生
        const filteredStudents = this.filteredStudents;
        console.log('selectClass - 过滤后的学生数量:', filteredStudents.length);
        console.log('selectClass - 过滤后的学生:', filteredStudents);
      },

      // 获取班级显示名称（用于选择器）
      getClassDisplayName(item) {
        if (!item) return '未知班级'

        const gradeName = item.grade_name || item.gradeName || item.name
        if (gradeName) {
          return `${gradeName}(${item.id})`
        } else {
          return `班级${item.id}`
        }
      },

      // 获取班级名称
      getClassName(classId) {
        console.log('getClassName - 查找班级ID:', classId)
        console.log('getClassName - 班级列表:', this.classList)

        // 尝试多种可能的字段名匹配
        const classInfo = this.classList.find(c => {
          const match = c.id === classId ||
                       c.gradeId === classId ||
                       c.grade_id === classId
          if (match) {
            console.log('getClassName - 找到匹配的班级信息:', c)
          }
          return match
        });

        if (classInfo) {
          // 优先使用 grade_name 字段，然后尝试其他字段
          const gradeName = classInfo.grade_name || classInfo.gradeName || classInfo.name
          console.log('getClassName - 班级名称字段:', gradeName)
          if (gradeName) {
            // 为了测试方便，在班级名称后面显示ID
            return `${gradeName}(${classId})`
          } else {
            return `班级${classId}`
          }
        } else {
          console.log('getClassName - 未找到班级信息，使用默认格式')
          return `班级${classId}`
        }
      },

      // 获取作业发布班级显示文本
      getPublishedClassesDisplay(homework) {
        // 首先检查是否有缓存的班级名称
        if (this.publishedClassesMap[homework.id]) {
          return this.publishedClassesMap[homework.id]
        }

        // 如果没有缓存，尝试实时计算
        if (homework.published) {
          let gradeIds = []
          if (homework.gradeIds && homework.gradeIds.length > 0) {
            gradeIds = homework.gradeIds
          } else if (homework.gradeId) {
            gradeIds = [homework.gradeId]
          } else if (homework.grade_id) {
            gradeIds = [homework.grade_id]
          }

          if (gradeIds.length > 0) {
            const classNames = gradeIds.map(classId => {
              const classInfo = this.classList.find(c =>
                c.id === classId || c.gradeId === classId || c.grade_id === classId
              )
              if (classInfo) {
                const gradeName = classInfo.grade_name || classInfo.gradeName || classInfo.name
                return gradeName || `班级${classId}`
              } else {
                return `班级${classId}`
              }
            })
            return classNames.join(', ')
          } else {
            return '未发布'
          }
        } else {
          return '未发布'
        }
      },

      // 获取班级提交人数
      getClassSubmissionCount(classId) {
        const submittedStudentIds = this.classSubmissionData[classId] || [];
        return submittedStudentIds.length;
      },

      // 获取班级学生人数
      getClassStudentCount(classId) {
        console.log('getClassStudentCount - 班级ID:', classId, '类型:', typeof classId);
        console.log('getClassStudentCount - homeworkStudentsByClass:', this.homeworkStudentsByClass);
        console.log('getClassStudentCount - 所有键:', Object.keys(this.homeworkStudentsByClass));

        const classStudents = this.homeworkStudentsByClass[classId];
        console.log('getClassStudentCount - 找到的班级数据:', classStudents);

        const count = classStudents ? classStudents.students.length : 0;
        console.log('getClassStudentCount - 学生人数:', count);

        return count;
      },

      // 获取所有学生
      getAllStudents() {
        const allStudents = [];
        Object.values(this.homeworkStudentsByClass).forEach(classData => {
          if (classData.students) {
            allStudents.push(...classData.students);
          }
        });
        return allStudents;
      },

      // 格式化日期
      formatDate(dateString) {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      },

      // 获取学生作业提交状态
      getSubmissionStatus(student) {
        // 使用student.id，因为t_homework_submit.student_id对应t_students.student_id
        const studentIdToUse = student.id;
        console.log('getSubmissionStatus - 查找学生:', studentIdToUse, '作业:', this.currentHomework.id);
        console.log('getSubmissionStatus - 当前studentStatuses:', this.studentStatuses);

        // 直接从studentStatuses中获取状态
        const status = this.studentStatuses[studentIdToUse];
        if (status) {
          console.log('getSubmissionStatus - 找到状态:', status);
          return status;
        } else {
          console.log('getSubmissionStatus - 未找到状态，返回默认值');
          return { type: 'danger', text: '未提交' };
        }
      },

      // 异步获取学生作业提交状态
      async getSubmissionStatusAsync(student) {
        try {
          // 使用student.id，因为t_homework_submit.student_id对应t_students.student_id
          const studentIdToUse = student.id;
          const response = await getSubmitByStudentIdAndHomeworkId(parseInt(studentIdToUse), parseInt(this.currentHomework.id));
          if (response.code === 1 && response.data) {
            return { type: 'success', text: '已提交' };
          } else {
            return { type: 'danger', text: '未提交' };
          }
        } catch (error) {
          console.error('获取提交状态失败:', error);
          return { type: 'info', text: '未知' };
        }
      },

      // 获取学生所属班级（这个方法需要根据实际的学生班级关系API来实现）
      async getStudentClass(studentId) {
        // 这里需要调用API获取学生所属的班级
        // 例如：GET /api/student/{studentId}/class
        // 暂时返回null，你可以根据实际API来实现
        return null;
      },

              // 数学公式渲染方法
      renderMathFormula(content) {
        if (!content) return '';

        try {
          if (window.katex) {
            let processedContent = content;

            // 先处理转义的内联数学公式 \\(...\\) - 这是后端数据的主要格式
            processedContent = processedContent.replace(/\\\\([^)]+)\\\\/g, (match, formula) => {
              try {
                return window.katex.renderToString(formula, {
                  throwOnError: false,
                  displayMode: false
                });
              } catch (e) {
                console.warn('转义内联公式渲染失败:', formula, e);
                return match;
              }
            });

            // 处理内联数学公式 \(...\)
            processedContent = processedContent.replace(/\\\(([^)]+)\\\)/g, (match, formula) => {
              try {
                return window.katex.renderToString(formula, {
                  throwOnError: false,
                  displayMode: false
                });
              } catch (e) {
                console.warn('内联公式渲染失败:', formula, e);
                return match;
              }
            });

            // 处理转义的块级数学公式 \\[...\\]
            processedContent = processedContent.replace(/\\\\\[([^\]]+)\\\]/g, (match, formula) => {
              try {
                return window.katex.renderToString(formula, {
                  throwOnError: false,
                  displayMode: true
                });
              } catch (e) {
                console.warn('转义块级公式渲染失败:', formula, e);
                return match;
              }
            });

            // 处理块级数学公式 \[...\]
            processedContent = processedContent.replace(/\\\[([^\]]+)\\\]/g, (match, formula) => {
              try {
                return window.katex.renderToString(formula, {
                  throwOnError: false,
                  displayMode: true
                });
              } catch (e) {
                console.warn('块级公式渲染失败:', formula, e);
                return match;
              }
            });

            // 处理美元符号包围的公式 $...$
            processedContent = processedContent.replace(/\$([^$]+)\$/g, (match, formula) => {
              try {
                return window.katex.renderToString(formula, {
                  throwOnError: false,
                  displayMode: false
                });
              } catch (e) {
                console.warn('美元符号公式渲染失败:', formula, e);
                return match;
              }
            });

            return processedContent;
          } else {
            // 如果没有KaTeX，使用简单的HTML替换
            let result = content;
            result = result.replace(/\\frac\{([^}]+)\}\{([^}]+)\}/g, '<sup>$1</sup>/<sub>$2</sub>');
            result = result.replace(/\\sqrt\{([^}]+)\}/g, '√$1');
            result = result.replace(/\^(\d+)/g, '<sup>$1</sup>');
            result = result.replace(/_(\d+)/g, '<sub>$1</sub>');
            result = result.replace(/\\\\([^)]+)\\\\/g, '');
            result = result.replace(/\\\(([^)]+)\\\)/g, '');
            result = result.replace(/\\\\\[([^\]]+)\\\]/g, '');
            result = result.replace(/\\\[([^\]]+)\\\]/g, '');
            return result;
          }
        } catch (error) {
          console.warn('数学公式渲染失败:', error);
          return content;
        }
      },

      async showCorrectionResult(student) {
        try {
          console.log('=== 开始批改结果查询 ===');
          console.log('showCorrectionResult - 学生数据:', student);
          console.log('showCorrectionResult - 作业数据:', this.currentHomework);
          console.log('showCorrectionResult - 学生ID字段:', student.id);
          console.log('showCorrectionResult - 学号字段:', student.student_num);
          console.log('showCorrectionResult - 作业ID:', this.currentHomework.id);

          // 使用新的t_homework_submit表获取学生提交记录
          // t_homework_submit.student_id对应t_students.student_id
          // 使用student.id，因为t_homework_submit.student_id对应t_students.student_id
          const studentIdToUse = student.id;
          console.log('使用id字段:', studentIdToUse);

          console.log('查询参数 - student_id:', parseInt(studentIdToUse), 'homework_id:', parseInt(this.currentHomework.id));
          const submitResponse = await getSubmitByStudentIdAndHomeworkId(parseInt(studentIdToUse), parseInt(this.currentHomework.id));
          console.log('submitResponse:', submitResponse);

          if (submitResponse.code === 1 && submitResponse.data) {
            // 有提交记录，获取详细信息
            // 加载整体作业评语
            this.homeworkComment = submitResponse.data.teacherComment || '';

            const detailsResponse = await getSubmitDetails(submitResponse.data.submitId);
            console.log('detailsResponse:', detailsResponse);

            if (detailsResponse.code === 1 && detailsResponse.data && detailsResponse.data.length > 0) {
              console.log('📝 有详细信息，构建studentSubmissions数组');

              // 检查answerImageUrl是否为数组（多张图片）
              let imageUrls = [];
              try {
                // 尝试解析JSON字符串
                if (typeof submitResponse.data.answerImageUrl === 'string') {
                  imageUrls = JSON.parse(submitResponse.data.answerImageUrl);
                } else if (Array.isArray(submitResponse.data.answerImageUrl)) {
                  imageUrls = submitResponse.data.answerImageUrl;
                } else {
                  imageUrls = [submitResponse.data.answerImageUrl];
                }
              } catch (e) {
                // 如果解析失败，说明是单张图片的URL字符串
                imageUrls = [submitResponse.data.answerImageUrl];
              }

              console.log('📝 原始answerImageUrl:', submitResponse.data.answerImageUrl);
              console.log('📝 解析后的图片URL数组:', imageUrls);

              // 构建学生提交记录数组 - 每张图片对应一个记录
              this.studentSubmissions = imageUrls.map((imageUrl, index) => {
                // 处理图片URL，构建完整的访问地址
                let processedImageUrl = imageUrl;
                if (imageUrl && !imageUrl.startsWith('http')) {
                  // MinIO文件直接通过MinIO API访问
                  if (imageUrl.startsWith('/question-info/')) {
                    // MinIO文件路径格式：/bucketName/fileName
                    processedImageUrl = `http://localhost:9000${imageUrl}`;
                    console.log('🔗 构建MinIO URL:', processedImageUrl);
                  } else {
                    // 其他文件通过本地文件系统访问
                    processedImageUrl = `http://localhost:8080/api/file/preview?path=${encodeURIComponent(imageUrl)}`;
                    console.log('🔗 构建本地文件URL:', processedImageUrl);
                  }
                }

                return {
                submitId: submitResponse.data.submitId,
                homeworkId: this.currentHomework.id,
                studentId: student.id,
                  imageUrl: processedImageUrl,
                submitTime: submitResponse.data.submitTime,
                  point: index < detailsResponse.data.length ? detailsResponse.data[index].studentScore : null,
                status: submitResponse.data.status
                };
              });
              console.log('📝 从detailsResponse构建的studentSubmissions:', this.studentSubmissions);
              console.log('📝 studentSubmissions长度:', this.studentSubmissions.length);
              console.log('📝 每张图片的详细信息:');
              this.studentSubmissions.forEach((submission, index) => {
                console.log(`  ${index}: ${submission.imageUrl}`);
              });
            } else {
              console.log('📝 没有详细信息，使用主记录构建studentSubmissions');

              // 检查answerImageUrl是否为数组（多张图片）
              let imageUrls = [];
              try {
                // 尝试解析JSON字符串
                if (typeof submitResponse.data.answerImageUrl === 'string') {
                  imageUrls = JSON.parse(submitResponse.data.answerImageUrl);
                } else if (Array.isArray(submitResponse.data.answerImageUrl)) {
                  imageUrls = submitResponse.data.answerImageUrl;
                } else {
                  imageUrls = [submitResponse.data.answerImageUrl];
                }
              } catch (e) {
                // 如果解析失败，说明是单张图片的URL字符串
                imageUrls = [submitResponse.data.answerImageUrl];
              }

              console.log('📝 原始answerImageUrl:', submitResponse.data.answerImageUrl);
              console.log('📝 解析后的图片URL数组:', imageUrls);

              // 构建学生提交记录数组 - 每张图片对应一个记录
              this.studentSubmissions = imageUrls.map(imageUrl => {
                // 处理图片URL，构建完整的访问地址
                let processedImageUrl = imageUrl;
                if (imageUrl && !imageUrl.startsWith('http')) {
                  // MinIO文件直接通过MinIO API访问
                  if (imageUrl.startsWith('/question-info/')) {
                    // MinIO文件路径格式：/bucketName/fileName
                    processedImageUrl = `http://localhost:9000${imageUrl}`;
                    console.log('🔗 构建MinIO URL:', processedImageUrl);
                  } else {
                    // 其他文件通过本地文件系统访问
                    processedImageUrl = `http://localhost:8080/api/file/preview?path=${encodeURIComponent(imageUrl)}`;
                    console.log('🔗 构建本地文件URL:', processedImageUrl);
                  }
                }

                return {
                submitId: submitResponse.data.submitId,
                homeworkId: this.currentHomework.id,
                studentId: student.id,
                  imageUrl: processedImageUrl,
                submitTime: submitResponse.data.submitTime,
                point: null,
                status: submitResponse.data.status
                };
              });
              console.log('📝 从主记录构建的studentSubmissions:', this.studentSubmissions);
              console.log('📝 studentSubmissions长度:', this.studentSubmissions.length);
              console.log('📝 每张图片的详细信息:');
              this.studentSubmissions.forEach((submission, index) => {
                console.log(`  ${index}: ${submission.imageUrl}`);
              });
            }
          } else {
            // 没有提交记录
            this.studentSubmissions = [];
          }

          console.log('studentSubmissions数组:', this.studentSubmissions);
          console.log('studentSubmissions长度:', this.studentSubmissions.length);

          if (this.studentSubmissions.length > 0) {
            this.currentImageIndex = 0;
            // 确保图片URL是完整的URL
            let imageUrl = this.studentSubmissions[0].imageUrl;
            console.log('studentSubmissions[0]:', this.studentSubmissions[0]);
            console.log('原始图片URL:', imageUrl);
            console.log('图片URL类型:', typeof imageUrl);
            console.log('图片URL是否为空:', !imageUrl);
            console.log('图片URL长度:', imageUrl ? imageUrl.length : 0);
            console.log('图片URL是否以http开头:', imageUrl ? imageUrl.startsWith('http') : false);
            console.log('图片URL是否以/question-info/开头:', imageUrl ? imageUrl.startsWith('/question-info/') : false);

            if (imageUrl && !imageUrl.startsWith('http')) {
              // MinIO文件直接通过MinIO API访问
              if (imageUrl.startsWith('/question-info/')) {
                // MinIO文件路径格式：/bucketName/fileName
                imageUrl = `http://localhost:9000${imageUrl}`;
                console.log('🔗 构建MinIO URL:', imageUrl);
              } else {
                // 其他文件通过本地文件系统访问
                imageUrl = `http://localhost:8080/api/file/preview?path=${encodeURIComponent(imageUrl)}`;
                console.log('🔗 构建本地文件URL:', imageUrl);
              }
              console.log('处理后的图片URL:', imageUrl);
            } else {
              console.log('图片URL已经是完整URL或为空，无需处理');
            }
            // 设置第一张图片为当前显示的图片
            this.studentImageUrl = imageUrl;
            this.currentImageIndex = 0; // 重置索引为第一张图片
            console.log('最终设置的studentImageUrl:', this.studentImageUrl);
            console.log('🎯 图像显示测试 - 请检查浏览器网络面板中是否有图片请求');
          } else {
            this.studentImageUrl = '';
            console.log('没有提交记录，设置studentImageUrl为空');
          }

          this.currentStudent = student;
          this.currentStudentScore = this.studentSubmissions.length > 0 ? this.studentSubmissions[0].point : null;

          // 处理不同类型作业的批改结果
          if (this.currentHomework.isImageType) {
            // 图片作业只显示图片，无需加载题目
            this.correctionResults = [];
          } else {
            // 普通作业处理逻辑
            // 如果有提交记录，从提交详情中获取批改结果
            if (this.studentSubmissions.length > 0 && submitResponse.code === 1 && submitResponse.data) {
              try {
                const detailsResponse = await getSubmitDetails(submitResponse.data.submitId);
                if (detailsResponse.code === 1 && detailsResponse.data && detailsResponse.data.length > 0) {
                  console.log('📝 有批改详情，从提交详情构建批改结果');
                  // 从提交详情构建批改结果
                  console.log('原始提交详情数据:', detailsResponse.data);
                  this.correctionResults = detailsResponse.data.map(detail => {
                    const result = {
                      id: detail.questionId,
                      questionId: detail.questionId,
                      stem: '', // 需要从题目详情中获取
                      judge: detail.isCorrect === 1 ? '正确' : detail.isCorrect === 0 ? '错误' : '未批改',
                      comment: detail.teacherComment || '',
                      point: detail.studentScore || 0, // 使用studentScore字段
                      answerText: detail.answerText || '',
                      answerImageUrl: detail.answerImageUrl || ''
                    };
                    console.log(`题目${detail.questionId}的批改结果:`, result);
                    return result;
                  });

                  // 获取题目详情来填充题目内容
                  const questionsRes = await getSpecificHomeworkQuestions(this.currentHomework.id);
                  console.log('获取题目详情响应:', questionsRes);
                  if (questionsRes && questionsRes.code === 1 && questionsRes.data) {
                    this.correctionResults = this.correctionResults.map(result => {
                      const question = questionsRes.data.find(q => q.questionId === result.questionId);
                      console.log('匹配题目:', {
                        resultQuestionId: result.questionId,
                        question: question,
                        questionContent: question ? question.content : 'N/A'
                      });
                      return {
                        ...result,
                        stem: question ? (question.content || question.stem || '') : result.stem
                      };
                    });
                    console.log('最终批改结果:', this.correctionResults);
                  }
                } else {
                  console.log('📝 没有批改详情，从作业题目构建答题列表');
                  // 没有批改详情，用作业题目详情填充
                  await this.loadDefaultCorrectionResults();
                }
              } catch (error) {
                console.error('获取批改详情失败:', error);
                await this.loadDefaultCorrectionResults();
              }
            } else {
              // 没有提交记录，用作业题目详情填充
              await this.loadDefaultCorrectionResults();
            }
          }

          this.studentListVisible = false;
          this.correctionResultVisible = true;
        } catch (error) {
          this.$message.error('获取批改结果失败');
          console.error(error);
        }
      },

      // 切换到上一张图片
      prevImage() {
        console.log('🔄 prevImage 按钮被点击');
        console.log('prevImage - 当前索引:', this.currentImageIndex);
        console.log('prevImage - 总数量:', this.studentSubmissions.length);
        console.log('prevImage - studentSubmissions:', this.studentSubmissions);

        if (this.currentImageIndex > 0) {
          this.currentImageIndex--;
          console.log('prevImage - 切换到索引:', this.currentImageIndex);
          console.log('prevImage - 新图片URL:', this.studentSubmissions[this.currentImageIndex]?.imageUrl);

          this.studentImageUrl = this.studentSubmissions[this.currentImageIndex].imageUrl;
          this.currentStudentScore = this.studentSubmissions[this.currentImageIndex].point;

          console.log('prevImage - 更新后的studentImageUrl:', this.studentImageUrl);
        } else {
          console.log('prevImage - 已经是第一张图片');
        }
      },

      // 切换到下一张图片
      nextImage() {
        console.log('🔄 nextImage 按钮被点击');
        console.log('nextImage - 当前索引:', this.currentImageIndex);
        console.log('nextImage - 总数量:', this.studentSubmissions.length);
        console.log('nextImage - studentSubmissions:', this.studentSubmissions);
        console.log('nextImage - 当前图片URL:', this.studentSubmissions[this.currentImageIndex]?.imageUrl);

        if (this.currentImageIndex < this.studentSubmissions.length - 1) {
          this.currentImageIndex++;
          console.log('nextImage - 切换到索引:', this.currentImageIndex);
          console.log('nextImage - 新图片URL:', this.studentSubmissions[this.currentImageIndex]?.imageUrl);

          this.studentImageUrl = this.studentSubmissions[this.currentImageIndex].imageUrl;
          this.currentStudentScore = this.studentSubmissions[this.currentImageIndex].point;

          console.log('nextImage - 更新后的studentImageUrl:', this.studentImageUrl);
        } else {
          console.log('nextImage - 已经是最后一张图片');
        }
      },

      async saveCorrectionResults() {
        try {
          console.log('saveCorrectionResults - 当前学生数据:', this.currentStudent);
          console.log('saveCorrectionResults - 当前作业数据:', this.currentHomework);

          const studentId = this.currentStudent && this.currentStudent.id; // 使用id字段，不是student_num
          const homeworkId = this.currentHomework && this.currentHomework.id;

          console.log('saveCorrectionResults - 学生ID:', studentId);
          console.log('saveCorrectionResults - 学号:', this.currentStudent && this.currentStudent.student_num);
          console.log('saveCorrectionResults - 作业ID:', homeworkId);

          // 获取提交记录ID
          if (!this.studentSubmissions || this.studentSubmissions.length === 0) {
            this.$message.error('未找到学生提交记录');
            return;
          }

          const submitId = this.studentSubmissions[0].submitId;
          console.log('saveCorrectionResults - 提交ID:', submitId);

          // 构建批改详情数据
          const details = this.correctionResults.map(result => ({
            questionId: result.id || result.questionId,
            studentScore: Number(result.point) || 0,
            teacherComment: result.comment || '',
            isCorrect: result.judge === '正确' ? 1 : (result.judge === '错误' ? 0 : null)
          }));

          console.log('saveCorrectionResults - 批改详情:', details);

          // 使用新的API保存批改结果
          await gradeHomework(submitId, details, this.homeworkComment);

          // 计算总分
          const totalPoint = details.reduce((sum, detail) => sum + (detail.studentScore || 0), 0);
          console.log('saveCorrectionResults - 总分:', totalPoint);

          // 自动添加错误题目到错题本（如果用户选择了该选项）
          if (this.autoAddToWrongBook) {
            const wrongResults = this.correctionResults.filter(r => r.judge === '错误');
            if (wrongResults.length > 0) {
              await this.addWrongQuestionsToUserbook(wrongResults, studentId);
            }
          }

          this.$message.success('批改完成');

          // 批改完成后，返回到学生列表，而不是关闭整个对话框
          // 重新加载学生提交状态数据，以显示最新的批改结果
          await this.loadStudentSubmissionStatus();

          // 关闭批改结果对话框，重新显示学生列表对话框
          this.correctionResultVisible = false;
          this.studentListVisible = true;
        } catch (error) {
          this.$message.error('批改失败');
          console.error(error);
        }
      },

      // 重新加载学生提交状态数据
      async loadStudentSubmissionStatus() {
        if (!this.currentHomework || !this.currentHomework.id) {
          console.warn('没有当前作业信息，无法重新加载学生提交状态');
          return;
        }

        try {
          console.log('重新加载学生提交状态数据...');

          // 清空现有的提交状态数据
          this.submissions = [];
          this.studentStatuses = {};

          // 为每个学生检查提交状态和批改状态
          for (const classData of Object.values(this.homeworkStudentsByClass)) {
            if (classData.students) {
              for (const student of classData.students) {
                const studentIdToUse = this.resolveStudentId(student);

                try {
                  const response = await getSubmitByStudentIdAndHomeworkId(parseInt(studentIdToUse), parseInt(this.currentHomework.id));
                  if (response.code === 1 && response.data) {
                    // 有提交记录
                    this.submissions.push({
                      homeworkId: this.currentHomework.id,
                      studentId: studentIdToUse,
                      submitted: true,
                      status: response.data.submitStatus,
                      point: response.data.totalScore || null,
                      submitTime: response.data.submitTime
                    });

                    // 检查批改状态
                    try {
                      const detailsResponse = await getSubmitDetails(response.data.submitId);
                      if (detailsResponse.code === 1 && detailsResponse.data && detailsResponse.data.length > 0) {
                        // 有批改详情，检查是否有实际的批改内容
                        const hasGrading = detailsResponse.data.some(detail =>
                          detail.isCorrect !== null ||
                          (detail.teacherComment && detail.teacherComment.trim() !== '') ||
                          (detail.studentScore && detail.studentScore > 0)
                        );
                        this.studentStatuses[studentIdToUse] = hasGrading
                          ? { type: 'success', text: '已批改' }
                          : { type: 'warning', text: '未批改' };
                      } else {
                        // 没有批改详情，说明已提交但未批改
                        this.studentStatuses[studentIdToUse] = { type: 'warning', text: '未批改' };
                      }
                    } catch (error) {
                      console.error(`检查学生${studentIdToUse}批改状态失败:`, error);
                      this.studentStatuses[studentIdToUse] = { type: 'info', text: '已提交' };
                    }
                  } else {
                    // 没有提交记录
                    this.submissions.push({
                      homeworkId: this.currentHomework.id,
                      studentId: studentIdToUse,
                      submitted: false,
                      status: null,
                      point: null,
                      submitTime: null
                    });
                    this.studentStatuses[studentIdToUse] = { type: 'danger', text: '未提交' };
                  }
                } catch (error) {
                  console.warn(`获取学生${studentIdToUse}提交状态失败:`, error);
                  // 出错时也添加未提交记录
                  this.submissions.push({
                    homeworkId: this.currentHomework.id,
                    studentId: studentIdToUse,
                    submitted: false,
                    status: null,
                    point: null,
                    submitTime: null
                  });
                  this.studentStatuses[studentIdToUse] = { type: 'danger', text: '未提交' };
                }
              }
            }
          }

          console.log('重新加载后的学生提交状态数据:', this.submissions);
          console.log('重新加载后的学生状态数据:', this.studentStatuses);
        } catch (error) {
          console.error('重新加载学生提交状态失败:', error);
        }
      },

      // 解析学生ID，兼容不同字段
      resolveStudentId(student) {
        if (!student) return null
        // 优先使用明确的student_id，其次id，再次userId，最后学号（需要后端兼容）
        return student.student_id || student.studentId || student.id || student.userId || student.student_num || student.studentNum
      },

      // ============ 上传作业图片相关方法 ============

      // 显示上传作业图片弹窗（未完成状态）
      showUploadDialog(student) {
        this.currentUploadStudent = student;
        this.uploadDialogTitle = '上传作业图片';
        this.uploadFileList = [];
        this.uploadImageDialogVisible = true;
      },

      // 显示重新上传作业图片弹窗（已完成状态）
      showReuploadDialog(student) {
        this.currentUploadStudent = student;
        this.uploadDialogTitle = '重新上传作业图片';
        this.uploadFileList = [];
        this.uploadImageDialogVisible = true;
      },

      // 处理上传文件变化
      handleUploadFileChange(file, fileList) {
        this.uploadFileList = fileList;
      },

      // 处理上传文件移除
      handleUploadFileRemove(file, fileList) {
        this.uploadFileList = fileList;
      },

      // 处理上传弹窗关闭
      handleUploadDialogClose() {
        this.uploadImageDialogVisible = false;
        this.currentUploadStudent = null;
        this.uploadFileList = [];
        this.uploadingImage = false;
      },

      // 提交上传图片
      async submitUploadImage() {
        if (!this.currentUploadStudent || !this.currentHomework) {
          this.$message.error('缺少必要信息，无法上传');
          return;
        }

        if (this.uploadFileList.length === 0) {
          this.$message.warning('请选择要上传的图片');
          return;
        }

        this.uploadingImage = true;

        try {
          const studentId = this.resolveStudentId(this.currentUploadStudent);

          console.log('开始上传作业图片:', {
            studentId: studentId,
            studentName: this.currentUploadStudent.name,
            homeworkId: this.currentHomework.id,
            fileCount: this.uploadFileList.length
          });

          // 上传多张图片
          const uploadedImages = [];

          // 逐个上传图片
          for (let i = 0; i < this.uploadFileList.length; i++) {
            const file = this.uploadFileList[i].raw;
          const uploadFormData = new FormData();
          uploadFormData.append('file', file);
            uploadFormData.append('homeworkId', this.currentHomework.id);
            uploadFormData.append('studentId', studentId);

            console.log(`上传第${i + 1}张图片:`, file.name);

            const response = await uploadHomeworkImage(uploadFormData);

            if (!response || response.code !== 1) {
              throw new Error(`第${i + 1}张图片上传失败: ${response?.msg || '未知错误'}`);
            }

            uploadedImages.push(response.data);
            console.log(`第${i + 1}张图片上传成功:`, response.data);
          }

          // 使用最后一张图片的响应作为提交记录
          const submissionResponse = { code: 1, data: uploadedImages[uploadedImages.length - 1] };

          console.log('所有上传的图片URL:', uploadedImages);

          if (!submissionResponse || submissionResponse.code !== 1) {
            throw new Error(submissionResponse?.msg || '提交记录创建失败');
          }

          console.log('提交记录创建成功:', submissionResponse);

          // 3. 立即更新该学生的状态为"未批改"
          this.$set(this.studentStatuses, studentId, { type: 'warning', text: '未批改' });

          // 4. 更新submissions数组中的记录
          const existingSubmissionIndex = this.submissions.findIndex(s =>
            s.homeworkId == this.currentHomework.id && s.studentId == studentId
          );

          const newSubmissionRecord = {
            homeworkId: this.currentHomework.id,
            studentId: studentId,
            submitted: true,
            status: 'submitted',
            point: null,
            submitTime: new Date().toISOString()
          };

          if (existingSubmissionIndex >= 0) {
            // 更新现有记录
            this.$set(this.submissions, existingSubmissionIndex, newSubmissionRecord);
          } else {
            // 添加新记录
            this.submissions.push(newSubmissionRecord);
          }

          console.log('学生状态已更新:', {
            studentId: studentId,
            studentName: this.currentUploadStudent.name,
            newStatus: this.studentStatuses[studentId]
          });

          // 5. 关闭弹窗并提示成功
          this.uploadImageDialogVisible = false;
          this.$message.success(`作业图片上传成功！共上传${uploadedImages.length}张图片`);

          // 6. 使用nextTick确保DOM更新，然后强制刷新
          this.$nextTick(() => {
          this.$forceUpdate();
            console.log('界面已强制刷新，当前学生状态:', this.studentStatuses[studentId]);

            // 7. 强制触发计算属性重新计算
            this.$nextTick(() => {
              // 通过修改一个响应式属性来触发计算属性重新计算
              this.refreshTrigger = Date.now();
              console.log('计算属性刷新触发器已更新:', this.refreshTrigger);

              // 8. 额外触发学生列表的重新渲染
              this.$nextTick(() => {
                // 强制重新计算filteredStudents
                const currentStudents = this.filteredStudents;
                console.log('filteredStudents重新计算完成，学生数量:', currentStudents.length);

                // 检查更新后的学生状态
                const updatedStudent = currentStudents.find(s =>
                  this.resolveStudentId(s) === studentId
                );
                if (updatedStudent) {
                  const newStatus = this.getSubmissionStatus(updatedStudent);
                  console.log('更新后的学生状态:', {
                    studentName: updatedStudent.name,
                    studentId: studentId,
                    status: newStatus
                  });
                }
              });
            });

            // 8. 额外触发一次数据更新，确保界面完全刷新
            setTimeout(() => {
              this.$forceUpdate();
              console.log('延迟刷新完成，确保界面更新');
            }, 100);
          });
        } catch (error) {
          console.error('上传作业图片失败:', error);
          this.$message.error('上传失败：' + (error.message || '未知错误'));
        } finally {
          this.uploadingImage = false;
        }
      },

      // 关闭批改对话框并返回学生提交列表
      async closeCorrectionDialog() {
        try {
          // 重新加载学生提交状态数据，确保显示最新状态
          await this.loadStudentSubmissionStatus();

          // 关闭批改结果对话框，显示学生提交列表
          this.correctionResultVisible = false;
          this.studentListVisible = true;

          // 确保学生列表按批改状态排序：未批改在前，已批改在后
          this.$nextTick(() => {
            // 触发计算属性重新计算，确保排序生效
            this.refreshTrigger = Date.now();
          });

          console.log('已返回学生提交列表，按批改状态排序：未批改在前，已批改在后');
        } catch (error) {
          console.error('关闭批改对话框时出错:', error);
          // 即使出错也要关闭对话框并显示学生列表
          this.correctionResultVisible = false;
          this.studentListVisible = true;
        }
      },

      // 加载默认的批改结果（当没有提交记录或批改详情时）
      async loadDefaultCorrectionResults() {
        try {
          const questionsRes = await getSpecificHomeworkQuestions(this.currentHomework.id);
          console.log('loadDefaultCorrectionResults - 获取题目详情响应:', questionsRes);
          if (questionsRes && questionsRes.code === 1 && questionsRes.data) {
            this.correctionResults = questionsRes.data.map(q => ({
              id: q.questionId,
              questionId: q.questionId,
              stem: q.content || q.stem || '',
              judge: '未批改', // 未批改
              comment: '',
              point: 0, // 新增分数字段
              answerText: '', // 无学生答案
              answerImageUrl: '' // 无学生答案图片
              // 不包含 ...q，避免覆盖学生答案字段
            }));
          } else {
            this.correctionResults = [];
          }
        } catch (error) {
          console.error('加载默认批改结果失败:', error);
          this.correctionResults = [];
        }
      },

      // 预览图片
      previewImage(imageUrl) {
        console.log('🖼️ previewImage 被调用');
        console.log('🖼️ previewImage - 原始数据:', imageUrl);
        console.log('🖼️ previewImage - 数据类型:', typeof imageUrl);
        console.log('🖼️ previewImage - 是否为数组:', Array.isArray(imageUrl));

        if (imageUrl) {
          let images = [];

          // 处理不同类型的图片数据
          if (typeof imageUrl === 'string') {
            try {
              // 尝试解析JSON字符串
              images = JSON.parse(imageUrl);
              console.log('🖼️ previewImage - JSON解析成功:', images);
            } catch (e) {
              // 如果解析失败，说明是单张图片的URL字符串
              images = [imageUrl];
              console.log('🖼️ previewImage - JSON解析失败，使用单张图片:', images);
            }
          } else if (Array.isArray(imageUrl)) {
            images = imageUrl;
            console.log('🖼️ previewImage - 直接使用数组:', images);
          } else {
            images = [imageUrl];
            console.log('🖼️ previewImage - 转换为数组:', images);
          }

          console.log('🖼️ previewImage - 最终图片数组:', images);
          console.log('🖼️ previewImage - 图片数组长度:', images.length);

          if (images.length === 1) {
            // 单张图片，直接在新窗口打开
            window.open(images[0], '_blank');
          } else if (images.length > 1) {
            // 多张图片，显示图片查看器
            this.studentImages = images;
            this.currentImageIndex = 0;
            this.studentImageDialogVisible = true;
          }
        }
      },

      // 显示学生作业图片
      showStudentImages(images) {
        console.log('🖼️ showStudentImages 被调用');
        console.log('🖼️ showStudentImages - 传入的images:', images);
        console.log('🖼️ showStudentImages - images类型:', typeof images);
        console.log('🖼️ showStudentImages - images是否为数组:', Array.isArray(images));
        console.log('🖼️ showStudentImages - images长度:', images ? images.length : 'undefined');

        if (images && images.length > 0) {
          this.studentImages = images;
          this.currentImageIndex = 0;
          this.studentImageDialogVisible = true;
          console.log('🖼️ showStudentImages - 设置studentImages:', this.studentImages);
          console.log('🖼️ showStudentImages - 设置currentImageIndex:', this.currentImageIndex);
        } else {
          console.log('🖼️ showStudentImages - 没有图片数据');
          this.$message.info('该学生暂无作业图片');
        }
      },

      // 上一张图片（学生图片查看器）
      viewerPreviousImage() {
        console.log('🔄 学生图片查看器 - viewerPreviousImage 按钮被点击');
        console.log('学生图片查看器 - viewerPreviousImage - 当前索引:', this.currentImageIndex);
        console.log('学生图片查看器 - viewerPreviousImage - 总数量:', this.studentImages.length);
        console.log('学生图片查看器 - viewerPreviousImage - studentImages数组:', this.studentImages);

        if (this.currentImageIndex > 0) {
          this.currentImageIndex--;
          console.log('学生图片查看器 - previousImage - 切换到索引:', this.currentImageIndex);
          console.log('学生图片查看器 - previousImage - 新图片URL:', this.studentImages[this.currentImageIndex]);
        } else {
          console.log('学生图片查看器 - previousImage - 已经是第一张图片');
        }
      },

      // 下一张图片（学生图片查看器）
      viewerNextImage() {
        console.log('🔄 学生图片查看器 - viewerNextImage 按钮被点击');
        console.log('学生图片查看器 - viewerNextImage - 当前索引:', this.currentImageIndex);
        console.log('学生图片查看器 - viewerNextImage - 总数量:', this.studentImages.length);
        console.log('学生图片查看器 - viewerNextImage - studentImages数组:', this.studentImages);
        console.log('学生图片查看器 - viewerNextImage - 当前图片URL:', this.studentImages[this.currentImageIndex]);

        if (this.currentImageIndex < this.studentImages.length - 1) {
          this.currentImageIndex++;
          console.log('学生图片查看器 - nextImage - 切换到索引:', this.currentImageIndex);
          console.log('学生图片查看器 - nextImage - 新图片URL:', this.studentImages[this.currentImageIndex]);
        } else {
          console.log('学生图片查看器 - nextImage - 已经是最后一张图片');
        }
      },

      // 选择指定图片
      selectImage(index) {
        if (index >= 0 && index < this.studentImages.length) {
          this.currentImageIndex = index;
        }
      },

      handleJudgeChange(index, val) {
        this.correctionResults[index].judge = val
      },

      async showStudentImage() {
        console.log('🖼️ showStudentImage 被调用');
        if (!this.currentStudent || !this.currentHomework) {
          this.$message.warning('未获取到学生或作业信息')
          return
        }
        try {
          const res = await axios.get('http://localhost:8080/api/student-submissions')
          if (Array.isArray(res.data)) {
            const submission = res.data.find(
              s => s.homeworkId === this.currentHomework.id && s.studentId === this.currentStudent.student_num
            )
            if (submission && submission.imageUrl) {
              this.studentImageUrl = submission.imageUrl

              // 处理图片URL，设置studentImages数组
              let images = [];
              if (typeof submission.imageUrl === 'string') {
                try {
                  images = JSON.parse(submission.imageUrl);
                } catch (e) {
                  images = [submission.imageUrl];
                }
              } else if (Array.isArray(submission.imageUrl)) {
                images = submission.imageUrl;
              } else {
                images = [submission.imageUrl];
              }

              this.studentImages = images;
              this.currentImageIndex = 0;
              console.log('🖼️ showStudentImage - 设置studentImages:', this.studentImages);
              console.log('🖼️ showStudentImage - 设置currentImageIndex:', this.currentImageIndex);
            } else {
              this.studentImageUrl = ''
              this.studentImages = [];
              this.currentImageIndex = 0;
              this.$message.info('未找到该学生的作业图片')
            }
          }
          this.studentImageDialogVisible = true
        } catch (e) {
          this.$message.error('获取作业图片失败')
          this.studentImages = [];
          this.currentImageIndex = 0;
          this.studentImageDialogVisible = true
        }
      },

      handleImageWheel(e) {
        const delta = e.deltaY < 0 ? 0.1 : -0.1
        let newScale = this.imageScale + delta
        newScale = Math.max(0.2, Math.min(newScale, 5))
        this.imageScale = newScale
      },

      startDrag(e) {
        if (e.button !== 0) return // 只响应左键
        this.dragging = true
        this.dragStart = { x: e.clientX, y: e.clientY }
        this.lastOffset = { ...this.imageOffset }
        window.addEventListener('mousemove', this.onDrag)
        window.addEventListener('mouseup', this.stopDrag)
      },
      stopDrag() {
        this.dragging = false
        window.removeEventListener('mousemove', this.onDrag)
        window.removeEventListener('mouseup', this.stopDrag)
      },
      onDrag(e) {
        if (!this.dragging) return
        this.imageOffset = {
          x: this.lastOffset.x + (e.clientX - this.dragStart.x),
          y: this.lastOffset.y + (e.clientY - this.dragStart.y)
        }
      },

      async addWrongQuestion(question) {
        try {
          const userId = localStorage.getItem('userId')
          if (!userId) {
            this.$message.error('用户ID不存在')
            return
          }

          // 获取题目详情
          const detailRes = await getQuestionDetail(question.id)
          if (!detailRes || !detailRes.data) {
            this.$message.error('获取题目详情失败')
            return
          }

          await addWrongQuestion({
            student_id: userId,
            content: question.stem,
            analysis: question.comment || '',
            knowledge: detailRes.data.knowledge || '',
            chapter: '',
            suboptions: '数学',
            answer: detailRes.data.answer || ''
          })

          this.$message.success('添加错题成功')
        } catch (error) {
          console.error('添加错题失败:', error)
          this.$message.error('添加错题失败')
        }
      },

      // 自动添加错误题目到学生的错题本
      async addWrongQuestionsToUserbook(results, studentId) {
        try {
          // 验证参数
          if (!studentId) {
            console.warn('学生ID为空，无法添加错题到错题本');
            return;
          }

          if (!Array.isArray(results) || results.length === 0) {
            console.log('没有批改结果，无法添加错题到错题本');
            return;
          }

          // 筛选出判断为错误的题目
          const wrongQuestions = results.filter(result => result.judge === 'error');

          if (wrongQuestions.length === 0) {
            console.log('没有错误题目需要添加到错题本');
            return;
          }

          console.log(`发现 ${wrongQuestions.length} 道错误题目，正在添加到错题本...`);

          let successCount = 0;
          let failCount = 0;

          // 检查是否是图片作业
          const isImageHomework = this.currentHomework && this.currentHomework.isImageType;

          // 为每个错误题目添加到错题本
          for (const question of wrongQuestions) {
            try {
              // 尝试获取题目详情以获取更完整的信息
              let questionDetail = null;
              if (question.id && !isImageHomework) {
                try {
                  const detailRes = await getQuestionDetail(question.id);
                  if (detailRes && detailRes.data) {
                    questionDetail = detailRes.data;
                  }
                } catch (detailError) {
                  console.warn('获取题目详情失败，使用现有数据:', detailError);
                }
              }

              // 构建错题数据
              const wrongQuestionData = {
                studentId: studentId, // 使用学生ID
                content: question.stem || question.content || questionDetail?.content || '', // 题目内容
                analysis: question.comment || questionDetail?.analysis || '', // 教师评语或题目解析
                knowledge: question.knowledge || question.chapter || questionDetail?.knowledge || '', // 知识点
                chapter: question.chapter || questionDetail?.chapter || '', // 章节
                suboptions: '数学', // 默认学科
                answer: question.answer || questionDetail?.answer || '' // 正确答案
              };

              // 对于图片作业，如果没有题目内容，尝试从图片URL生成描述
              if (isImageHomework && !wrongQuestionData.content.trim() && this.studentImageUrl) {
                wrongQuestionData.content = `图片作业题目 (来自作业: ${this.currentHomework.name || '未知作业'})`;
              }

              // 验证必要字段
              if (!wrongQuestionData.content.trim()) {
                console.warn('题目内容为空，跳过添加');
                failCount++;
                continue;
              }

              console.log('添加错题数据:', wrongQuestionData);

              // 调用API添加错题
              await addWrongQuestion(wrongQuestionData);
              successCount++;
            } catch (error) {
              console.error(`添加错题失败 (题目: ${question.stem || question.content}):`, error);
              failCount++;
              // 继续处理其他题目，不中断整个流程
            }
          }

          // 显示结果消息
          if (successCount > 0) {
            let message = `已成功将 ${successCount} 道错误题目添加到学生错题本`;
            if (failCount > 0) {
              message += `，${failCount} 道题目添加失败`;
            }
            this.$message.success(message);
          } else if (failCount > 0) {
            this.$message.warning(`${failCount} 道错误题目添加失败，请检查网络连接或稍后重试`);
          }
        } catch (error) {
          console.error('批量添加错题到错题本失败:', error);
          // 不显示错误消息，避免影响正常的批改保存流程
        }
      },

      async prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--
          await this.fetchCorrectionResults()
        }
      },

      async nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++
          await this.fetchCorrectionResults()
        }
      },

      async fetchCorrectionResults() {
        try {
          const res = await getCorrectionResult(this.currentHomework.id, this.currentStudent.student_num, this.currentPage)
          if (res && res.data) {
            this.correctionResults = res.data
            this.totalPages = res.totalPages
          }
        } catch (error) {
          console.error('获取批改结果失败', error);
          this.$message.error('获取批改结果失败');
        }
      },

      // 识别学生作答结果
      async recognizeStudentAnswers() {
        if (!this.studentImageUrl) {
          this.$message.warning('没有可识别的作业图片');
          return;
        }

        this.recognizing = true;
        try {
          console.log('开始AI识别学生作答结果...');
          console.log('图片URL:', this.studentImageUrl);
          console.log('当前批改结果:', this.correctionResults);

          // 调用AI识别API
          const response = await this.callAIRecognitionAPI(this.studentImageUrl);

          if (response && response.success) {
            console.log('AI识别结果:', response.data);

            // 将识别结果填充到批改结果中
            this.fillRecognitionResults(response.data);

            this.$message.success('AI识别完成，已自动填充学生作答结果');
          } else {
            this.$message.error('AI识别失败: ' + (response?.message || '未知错误'));
          }
        } catch (error) {
          console.error('AI识别出错:', error);
          this.$message.error('AI识别出错: ' + error.message);
        } finally {
          this.recognizing = false;
        }
      },

      // 调用AI识别API
      async callAIRecognitionAPI(imageUrl) {
        // 这里需要根据实际的AI服务API进行调整
        // 示例：调用后端AI识别接口
        const response = await fetch('/api/ai/recognize-homework', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            imageUrl: imageUrl,
            homeworkId: this.currentHomework.id,
            questions: this.correctionResults.map(result => ({
              questionId: result.questionId,
              content: result.stem
            }))
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
      },

      // 填充识别结果到批改结果中
      fillRecognitionResults(recognitionData) {
        if (!recognitionData || !recognitionData.answers) {
          console.warn('识别结果中没有答案数据');
          return;
        }

        // 根据识别结果更新批改结果
        this.correctionResults = this.correctionResults.map(result => {
          const recognizedAnswer = recognitionData.answers.find(
            answer => answer.questionId === result.questionId
          );

          if (recognizedAnswer) {
            return {
              ...result,
              answerText: recognizedAnswer.answerText || result.answerText,
              answerImageUrl: recognizedAnswer.answerImageUrl || result.answerImageUrl
              // 可以根据识别结果自动判断对错（可选）
              // judge: recognizedAnswer.isCorrect ? '正确' : '错误'
            };
          }

          return result;
        });

        console.log('更新后的批改结果:', this.correctionResults);
      },

      // 显示OCR对话框
      showOcrDialog() {
        this.ocrDialogVisible = true;
        this.fileList = [];
        this.answersFileList = [];
      },

      // 处理文件变化（支持多选）
      handleFileChange(file, fileList) {
        this.fileList = fileList;
      },
      handleAnswersFileChange(file, fileList) {
        this.answersFileList = fileList;
      },

      // 删除文件
      handleFileRemove(file, fileList) {
        this.fileList = fileList;
      },
      handleAnswersFileRemove(file, fileList) {
        this.answersFileList = fileList;
      },

      // 处理图片上传
      // 将后端返回的题目类型字符串转换为前端使用的数字类型
      convertQuestionType(backendType) {
        const typeMapping = {
          'select': 1,
          'fill': 2,
          'judge': 3,
          'application': 4,
          'short_answer': 4, // 简答题对应application类型
          'multiple_choice': 1, // 选择题
          'true_false': 3, // 判断题
          'fill_blank': 2 // 填空题
        };
        return typeMapping[backendType] || 1; // 默认返回选择题类型
      },

      // 获取题目类型名称
      getQuestionTypeName(quType) {
        const typeMap = {
          1: '选择题',
          2: '填空题',
          3: '判断题',
          4: '计算题',
          5: '解答题'
        };
        return typeMap[quType] || '计算题';
      },

      // 格式化难度显示
      formatDifficulty(value) {
        if (value <= 0.3) return '简单';
        if (value <= 0.6) return '中等';
        if (value <= 0.8) return '较难';
        return '困难';
      },

      // 处理选项格式转换
      formatOptions(options, quType) {
        // 填空题和其他题型：options保持为空字符串
        if (quType !== 1) {
          return '';
        }

        if (!options) {
          return '';
        }

        // 选择题：处理各种可能的选项格式
        if (Array.isArray(options)) {
          // 数组格式：["A. 选项1", "B. 选项2"] -> "A. 选项1;B. 选项2"
          return options.join(';');
        } else if (typeof options === 'string') {
          // 字符串格式：检查是否已经是分号分隔
          if (options.includes(';')) {
            return options; // 已经是分号分隔格式
          } else if (options.includes(',')) {
            // 逗号分隔格式：转换为分号分隔
            return options.replace(/,/g, ';');
          } else {
            // 其他格式：直接返回
            return options;
          }
        }

        return '';
      },

      handleImageUpload() {
        if (!this.fileList || this.fileList.length === 0) {
          this.$message.warning('请选择题目图片后再上传！');
          return;
        }

        const loadingInstance = this.$loading({
          lock: true,
          text: 'OCR识别中，请稍后...（一次性上传多张图片）',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 后端要求：
        // - 多张题目图放在参数名 image 中（可多张）
        // - 参考答案图放在参数名 answers 中（1张）
        const formData = new FormData();
        this.fileList.forEach(f => {
          formData.append('image', f.raw);
        });
        // 参考答案：可选，若无则传 null 字符串
        if (this.answersFileList[0] && this.answersFileList[0].raw) {
          formData.append('answers', this.answersFileList[0].raw);
        } else {
          formData.append('answers', 'null');
        }

        processOcrImage(formData)
          .then(async (response) => {
            loadingInstance.close();
            console.log('OCR原始返回：', response);

            // 修复：正确访问response.data.questions
            const questions = response.data && response.data.questions ? response.data.questions : response.questions;
            if (!Array.isArray(questions) || questions.length === 0) {
              this.$message.warning('未识别到题目');
              return;
            }

            const questionsToSave = questions.map(question => {
              const quType = this.convertQuestionType(question.question_type);
              return {
                quType: quType,
                content: question.question_content || '',
                answer: question.answer || '',
                analysis: question.explanation || '',
                evaluate: question.evaluate || '考查学生对相关知识的理解和应用',
                repoId: parseInt(this.selectedRepoId) || 1,
                version: '人教版',
                knowledge: this.selectedKnowledgePoint || '未分类',
                chapter: null,
                options: this.formatOptions(question.options, quType),
                difficulty: parseFloat(question.difficulty) || 0.5,
                type: this.getQuestionTypeName(quType),
                level: parseInt(question.level) || 2
              };
            });

            try {
              const saveResponse = await saveOcrQuestions(questionsToSave);
              if (saveResponse.code === 1) {
                // 由于后端返回data为null，需要通过多种方式获取真实的题目ID
                const newQuestions = []
                for (const question of questionsToSave) {
                  let realId = null;

                  try {
                    // 方法1：通过内容查询获取真实题目ID
                    console.log('尝试通过内容查询题目ID:', question.content);
                    const contentQuery = await quDetailbyContent(question.content);
                    console.log('内容查询结果:', contentQuery);

                    if (contentQuery && contentQuery.data) {
                      if (Array.isArray(contentQuery.data) && contentQuery.data.length > 0 && contentQuery.data[0].id) {
                        realId = Number(contentQuery.data[0].id);
                      } else if (contentQuery.data.id) {
                        realId = Number(contentQuery.data.id);
                      }
                      if (realId) {
                        console.log('通过内容查询获取到ID:', realId);
                      }
                    }

                    // 方法2：如果内容查询失败，尝试通过题库查询
                    if (!realId && this.selectedRepoId) {
                      console.log('内容查询失败，尝试通过题库查询:', this.selectedRepoId);
                      const repoQuery = await getQuestionsByRepoId(this.selectedRepoId);
                      console.log('题库查询结果:', repoQuery);

                      if (repoQuery && repoQuery.data && Array.isArray(repoQuery.data)) {
                        const matched = repoQuery.data.find(q => (q.content || q.stem) === question.content);
                        if (matched && (matched.id || matched.questionId)) {
                          realId = Number(matched.id || matched.questionId);
                          console.log('通过题库查询获取到ID:', realId);
                        }
                      }
                    }

                    // 方法3：如果都失败，使用时间戳+随机数作为临时ID
                    if (!realId) {
                      realId = Date.now() + Math.random();
                      console.log('使用临时ID:', realId);
                    }

                    newQuestions.push({
                      id: realId,
                      content: question.content,
                      answer: question.answer,
                      knowledge: question.knowledge,
                      analysis: question.analysis,
                      quType: question.quType,
                      chapter: question.chapter,
                      point: question.point,
                      gradeId: 1,
                      createTime: question.createTime
                    });
                  } catch (e) {
                    console.error('查询题目ID失败:', e);
                    newQuestions.push({
                      id: Date.now() + Math.random(),
                      content: question.content,
                      answer: question.answer,
                      knowledge: question.knowledge,
                      analysis: question.analysis,
                      quType: question.quType,
                      chapter: question.chapter,
                      point: question.point,
                      gradeId: 1,
                      createTime: question.createTime
                    });
                  }
                }

                this.questionList = [...this.questionList, ...newQuestions];
                this.$nextTick(async () => {
                  // 不自动选择和加入右侧预览，保留在左侧列表供用户手动添加

                  // 自动保存到当前作业的关联表
                  if (this.currentHomework && this.currentHomework.id) {
                    try {
                      // 收集有效的题目ID（排除临时ID）
                      const validQuestionIds = newQuestions
                        .map(nq => Number(nq.id))
                        .filter(id => Number.isInteger(id) && id > 0);

                      console.log('所有题目ID:', newQuestions.map(nq => ({ id: nq.id, content: nq.content.substring(0, 20) })));
                      console.log('有效题目ID:', validQuestionIds);

                      if (validQuestionIds.length > 0) {
                        // 再次确保questionId为真实数据库ID，必要时按内容反查
                        const ensuredPayload = []
                        for (const nq of newQuestions) {
                          let idNum = Number(nq.id)
                          if (!Number.isInteger(idNum) || idNum <= 0 || idNum > 1000000) {
                            try {
                              const byContent = await quDetailbyContent(nq.content)
                              if (byContent && byContent.data) {
                                if (Array.isArray(byContent.data) && byContent.data.length > 0 && (byContent.data[0].id || byContent.data[0].questionId)) {
                                  idNum = Number(byContent.data[0].id || byContent.data[0].questionId)
                                } else if (byContent.data.id || byContent.data.questionId) {
                                  idNum = Number(byContent.data.id || byContent.data.questionId)
                                }
                              }
                            } catch (e) {
                              console.warn('OCR按内容反查题目ID失败：', nq.content, e)
                            }
                          }
                          if (Number.isInteger(idNum) && idNum > 0 && idNum < 1000000) {
                            ensuredPayload.push({
                              questionId: idNum,
                              content: nq.content || '',
                              quType: Number(nq.quType) || 1,
                              homeworkId: Number(this.currentHomework.id),
                              gradeId: 1,
                              point: Number(nq.point) || 10,
                              answer: nq.answer || ''
                            })
                          }
                        }
                        const relationsPayload = ensuredPayload
                        console.log('准备保存关联关系:', relationsPayload);
                        const saveHomeworkResponse = await saveSpecificHomework(this.currentHomework.id, relationsPayload);
                        if (saveHomeworkResponse.code === 1) {
                          console.log('OCR题目已自动保存到作业关联表');
                        } else {
                          console.warn('OCR题目保存到作业关联表失败:', saveHomeworkResponse.msg);
                        }
                      } else {
                        console.warn('未获取到有效题目ID，跳过保存关联表');
                        console.log('提示：题目已保存到数据库，但需要手动添加到作业中');
                      }
                    } catch (e) {
                      console.warn('自动保存OCR题目到作业关联表失败:', e);
                    }
                  }
                });
                this.$message.success(`OCR识别成功！已保存 ${newQuestions.length} 道题目到数据库并添加到题目列表`);
                this.ocrDialogVisible = false;
              } else {
                throw new Error(saveResponse.message || '保存失败');
              }
            } catch (saveError) {
              console.error('保存OCR题目到数据库失败:', saveError);
              this.$message.warning('OCR识别成功，但保存到数据库失败，题目已添加到列表但未保存');
              const newQuestions = questionsToSave.map(question => ({
                id: Date.now() + Math.random(),
                content: question.content,
                answer: question.answer,
                knowledge: question.knowledge,
                analysis: question.analysis,
                quType: question.quType,
                chapter: question.chapter,
                point: question.point,
                gradeId: 1, // 添加默认班级ID，避免保存作业时参数解析失败
                createTime: question.createTime
              }));
              this.questionList = [...this.questionList, ...newQuestions];
              this.$nextTick(async () => {
                newQuestions.forEach(q => this.selectedQuestions.push(q.id));
                // 识别成功（但保存失败）时，也自动加入右侧预览，避免丢失本次编辑
                if (typeof this.addSelectedQuestions === 'function') {
                  try { await this.addSelectedQuestions(); } catch (e) { console.warn('自动加入作业预览失败', e); }
                }
              });
              this.ocrDialogVisible = false;
            }
          })
          .catch((error) => {
            loadingInstance.close();
            console.error('OCR识别失败：', error);
            this.$message.error('OCR识别失败：' + (error.message || '未知错误'));
          });
      },

      // 处理OCR对话框关闭
      handleOcrDialogClose(done) {
        this.fileList = [];
        done();
      },

      showInputDialog() {
        this.inputDialogVisible = true
        // 重置表单
        this.inputQuestionForm = {
          quType: '',
          content: '',
          answer: '',
          knowledge: '',
          analysis: '',
          evaluate: '',
          options: '',
          difficulty: 0.5,
          level: 2
        }
      },

      async handleInputQuestion() {
        // 验证必填字段
        if (!this.inputQuestionForm.quType) {
          this.$message.warning('请选择题目类型')
          return
        }
        if (!this.inputQuestionForm.content) {
          this.$message.warning('请输入题目内容')
          return
        }

        // 准备保存到数据库的数据
        const questionToSave = {
          quType: this.inputQuestionForm.quType,
          content: this.inputQuestionForm.content,
          answer: this.inputQuestionForm.answer || '',
          analysis: this.inputQuestionForm.analysis || '',
          evaluate: this.inputQuestionForm.evaluate || '考查学生对相关知识的理解和应用',
          repoId: parseInt(this.selectedRepoId) || 1, // 确保是Integer类型
          version: '人教版',
          knowledge: this.selectedKnowledgePoint || '未分类',
          chapter: null, // 章节字段设为null
          options: this.formatOptions(this.inputQuestionForm.options, this.inputQuestionForm.quType), // 使用辅助方法处理选项格式
          difficulty: parseFloat(this.inputQuestionForm.difficulty) || 0.5, // 确保是BigDecimal类型
          type: this.getQuestionTypeName(this.inputQuestionForm.quType),
          level: parseInt(this.inputQuestionForm.level) || 2 // 确保是Integer类型
        };

        try {
          // 先保存到数据库
          const saveResponse = await saveOcrQuestions([
            questionToSave
          ]);

          if (saveResponse.code === 1) {
            console.log('手动输入题目已保存到数据库:', saveResponse);

            // 保存成功后，创建题目对象
            const newQuestion = {
              id: saveResponse.data && saveResponse.data[0] ? saveResponse.data[0].id : Date.now(),
              quType: questionToSave.quType,
              content: questionToSave.content,
              chapter: questionToSave.chapter,
              answer: questionToSave.answer,
              analysis: questionToSave.analysis,
              point: questionToSave.point,
              createTime: questionToSave.createTime
            };

            // 添加到左侧题目列表中
            this.questionList.push(newQuestion);

            // 自动选中新添加的题目
            this.$nextTick(() => {
              this.selectedQuestions.push(newQuestion.id);
            });

            this.$message.success('题目已保存到数据库并添加到题目列表！');
            this.inputDialogVisible = false;
          } else {
            throw new Error(saveResponse.message || '保存失败');
          }
        } catch (saveError) {
          console.error('保存手动输入题目到数据库失败:', saveError);
          this.$message.warning('保存到数据库失败，题目已添加到列表但未保存');

          // 即使保存失败，也添加到题目列表
          const newQuestion = {
            id: Date.now(),
            quType: questionToSave.quType,
            content: questionToSave.content,
            chapter: questionToSave.chapter,
            answer: questionToSave.answer,
            analysis: questionToSave.analysis,
            point: questionToSave.point,
            createTime: questionToSave.createTime
          };

          this.questionList.push(newQuestion);
          this.$nextTick(() => {
            this.selectedQuestions.push(newQuestion.id);
          });
          this.inputDialogVisible = false;
        }
      },

      // 获取作业统计信息
      async fetchHomeworkStats(homeworkId) {
        try {
          const response = await getHomeworkStats(homeworkId)
          if (response.code === 1) {
            this.homeworkStats = response.data
            return response.data
          } else {
            this.$message.warning(response.msg || '获取统计信息失败')
            return null
          }
        } catch (error) {
          console.error('获取作业统计信息失败:', error)
          this.$message.error('获取作业统计信息失败')
          return null
        }
      },

      // 显示自建作业对话框
      showImageHomeworkCreator() {
        this.imageHomeworkCreatorVisible = true
      },

      // 处理自建作业成功
      handleImageHomeworkCreated() {
        this.fetchHomeworkList() // 重新获取作业列表
      },

      // 打开批量上传对话框
      openBatchUpload(homework) {
        console.log('打开批量上传对话框，作业信息:', homework);
        console.log('课程ID:', this.courseId);

        // 确保作业对象有正确的结构
        this.currentBatchHomework = {
          id: homework.id,
          name: homework.name,
          ...homework
        };

        this.batchUploadVisible = true;

        console.log('设置后的currentBatchHomework:', this.currentBatchHomework);
        console.log('设置后的batchUploadVisible:', this.batchUploadVisible);

        // 强制更新组件
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },

      // 测试组件方法
      testComponent() {
        console.log('测试组件状态:');
        console.log('currentBatchHomework:', this.currentBatchHomework);
        console.log('batchUploadVisible:', this.batchUploadVisible);
        console.log('courseId:', this.courseId);

        // 强制重新渲染组件
        this.$forceUpdate();
        this.$message.info('组件状态已输出到控制台');
      },

      // 强制显示上传内容
      forceShowUploadContent() {
        console.log('强制显示上传内容');
        // 确保有有效的作业数据
        if (!this.currentBatchHomework || !this.currentBatchHomework.id) {
          this.currentBatchHomework = {
            id: 7,
            name: '作业1'
          };
        }

        this.$forceUpdate();
        this.$message.success('已强制显示内容，请尝试操作');
      },

      // 获取班级学生列表
      async fetchStudentList(gradeId) {
        // 实际项目中应该调用API获取学生列表
        // 这里使用模拟数据
        this.studentSelectList = [
          { id: 1, name: 'student', username: 'student' },
          { id: 2, name: 'student1', username: 'student1' },
          { id: 3, name: 'student2', username: 'student2' },
          { id: 4, name: 'student3', username: 'student3' },
          { id: 5, name: 'student5', username: 'student5' },
          { id: 6, name: 'student13', username: 'student13' },
          { id: 7, name: 'student14', username: 'student14' }
        ];
      }

    }
  };
  </script>

  <style scoped>
  /* 图片查看器样式 */
  .image-viewer-container {
    text-align: center;
  }

  .image-display-area {
    margin-bottom: 20px;
  }

  .image-controls {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
  }

  .image-counter {
    font-size: 14px;
    color: #666;
    font-weight: 500;
  }

  .image-thumbnails {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
    max-height: 120px;
    overflow-y: auto;
  }

  .thumbnail-item {
    width: 80px;
    height: 80px;
    border: 2px solid #ddd;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .thumbnail-item:hover {
    border-color: #409eff;
    transform: scale(1.05);
  }

  .thumbnail-item.active {
    border-color: #409eff;
    box-shadow: 0 0 8px rgba(64, 158, 255, 0.3);
  }

  .thumbnail-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .no-images {
    padding: 40px;
    color: #999;
  }

  .no-images p {
    margin-top: 10px;
    font-size: 14px;
  }
  </style>

  <style scoped>
  .action-column {
    white-space: nowrap;
  }

  /* 操作按钮样式 */
  .edit-btn {
    color: #4a90e2;
    /* 蓝色 */
    margin-right: 10px;
    cursor: pointer;
  }

  .publish-btn {
    color: #42b983;
    /* 绿色 */
    margin-right: 10px;
    cursor: pointer;
  }

  .delete-btn {
    color: #db2828;
    /* 红色 */
    margin-right: 10px;
    cursor: pointer;
  }

  .batch-upload-btn {
    color: #ff9800;
    /* 橙色 */
    margin-right: 10px;
    cursor: pointer;
  }

  /* 鼠标悬停效果 */
  .edit-btn:hover,
  .publish-btn:hover,
  .delete-btn:hover,
  .batch-upload-btn:hover {
    text-decoration: underline;
  }

  /* 加载状态样式 */
  .loading-content {
    text-align: center;
    color: #666;
  }

  .loading-content i {
    font-size: 24px;
    color: #409EFF;
    margin-bottom: 10px;
    display: block;
    animation: rotating 2s linear infinite;
  }

  .loading-content p {
    margin: 0;
    font-size: 14px;
  }

  @keyframes rotating {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .app-container {
    padding: 20px;
  }

  .header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .total-count {
    font-size: 1.2em;
    font-weight: 500;
  }

  .create-btn {
    padding: 8px 16px;
    background-color: #42b983;
    /* 绿色，可根据设计调整 */
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .homework-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
  }

  .homework-table th,
  .homework-table td {
    padding: 12px 15px;
    border: 1px solid #e4e7ed;
    text-align: left;
  }

  .homework-table th {
    background-color: #f5f7fa;
    font-weight: 600;
    font-size: 0.95em;
  }

  .action-column {
    white-space: nowrap;
  }

  .view-btn {
    color: #42b983;
    cursor: pointer;
    margin-left: 10px;
    /* 可以在这里添加图标字体，比如：font-awesome的fa-eye */
  }

  /* 原有样式保持不变，新增加载状态样式（可根据Element UI调整） */
  .el-loading-mask {
    z-index: 9999;
  }

  .homework-editor {
    height: 600px;
    display: flex;
    flex-direction: column;
  }

  .editor-container {
    display: flex;
    height: 100%;
    gap: 20px;
  }

  .editor-left {
    flex: 1;
    min-width: 350px;
    max-width: 50%;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: visible;
  }

  .editor-right {
    flex: 1;
    min-width: 350px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 15px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .editor-left h3,
  .editor-right h3 {
    margin-top: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #e4e7ed;
  }

  .question-list {
    flex: 1;
    overflow-y: auto;
    overflow-x: visible;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #909399;
  }

  .empty-state p {
    margin: 5px 0;
  }

  .preview-area {
    flex: 1;
    overflow-y: auto;
    background-color: #f5f7fa;
    border-radius: 4px;
    padding: 15px;
  }

  /* 确保弹窗内容可以滚动 */
  :deep(.el-dialog__body) {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }

  .knowledge-select {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
    display: flex;
    align-items: center;
  }

  .question-items {
    padding: 10px;
  }

  .question-item {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    transition: all 0.3s;
  }

  .question-item:hover {
    background-color: #f5f7fa;
  }

  .question-content {
    margin-left: 8px;
  }

  .question-title {
    font-weight: 500;
    margin-bottom: 5px;
  }

  .question-info {
    font-size: 12px;
    color: #909399;
  }

  .question-info span {
    margin-right: 15px;
  }

  .question-actions {
    padding: 10px;
    border-top: 1px solid #e4e7ed;
    text-align: center;
    background-color: #fff;
    position: sticky;
    bottom: 0;
  }

  /* 确保选择器和按钮在同一行 */
  .el-select {
    margin-right: 10px;
  }

  .preview-questions {
    padding: 15px;
  }

  .preview-question-item {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    margin-bottom: 15px;
    background-color: #fff;
  }

  .question-header {
    padding: 10px 15px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .question-number {
    font-weight: 500;
    color: #409EFF;
  }

  .question-body {
    padding: 15px;
  }

  .preview-question-item .question-content {
    margin-bottom: 10px;
    line-height: 1.6;
  }

  .preview-question-item .question-info {
    font-size: 12px;
    color: #909399;
  }

  .preview-question-item .question-info span {
    margin-right: 15px;
  }

  .delete-btn {
    color: #F56C6C;
  }

  .delete-btn:hover {
    color: #f78989;
  }

  .class-select-container {
    padding: 20px;
  }

  .student-name {
    color: #409EFF;
    cursor: pointer;
  }

  .student-name:hover {
    text-decoration: underline;
  }

  .student-info {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .student-info h3 {
    margin: 0;
    color: #303133;
  }

  .correction-dialog-body-beauty {
    display: flex;
    gap: 40px;
    align-items: flex-start;
    min-height: 400px;
    max-height: 70vh;
    overflow-x: auto;
    overflow-y: auto;
    background: #f7f8fa;
    border-radius: 12px;
    padding: 24px 0;
  }
  .correction-image-beauty {
    flex: 1 1 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    min-height: 400px;
    padding: 16px 8px 8px 8px;
    position: relative;
  }
  .no-image {
    color: #aaa;
    font-size: 16px;
    margin-top: 100px;
  }
  .zoom-tip {
    margin-top: 8px;
    color: #888;
    font-size: 13px;
    text-align: center;
  }
  .correction-table-beauty {
    flex: 1 1 50%;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.08);
    padding: 16px;
    overflow: auto;
  }
  .student-info {
    margin-bottom: 20px;
    padding: 10px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }
  .student-info h3 {
    margin: 0;
    color: #303133;
  }

  .upload-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .question-type-select {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .question-type-select .label {
    font-size: 14px;
    color: #606266;
    margin-bottom: 5px;
  }

  .el-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .el-radio {
    margin-right: 0;
  }

  .image-navigation {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    margin-top: 15px;
    padding: 10px;
    background: #f5f7fa;
    border-radius: 8px;
  }

  .image-counter {
    font-size: 14px;
    color: #606266;
    min-width: 60px;
    text-align: center;
  }

    .stats-cards {
      margin-bottom: 20px;
    }

    .no-class-selected {
      margin: 20px 0;
      text-align: center;
    }

  .stats-card {
    height: 120px;
  }

  .stats-card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  .stats-card-title {
    font-size: 16px;
    color: #606266;
    margin-bottom: 10px;
  }

  .stats-card-value {
    font-size: 28px;
    font-weight: bold;
    color: #409EFF;
  }

  .score-distribution-mini {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .distribution-item-mini {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    font-size: 14px;
  }

  .range-label-mini {
    color: #606266;
  }

  .count-value {
    font-weight: bold;
  }

  .buttons-group {
    display: flex;
    gap: 10px;
  }

  .image-create-btn {
    padding: 8px 16px;
    background-color: #409EFF;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .image-create-btn:hover {
    background-color: #66b1ff;
  }

  /* 错题本复选框样式 */
  .el-checkbox {
    font-size: 14px;
    color: #606266;
  }

  .el-checkbox__label {
    color: #606266;
  }

  /* 班级标签样式 - 现代化设计 */
  .class-tags-container {
    margin-bottom: 24px;
    padding: 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;
  }

  .class-tags-container::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #3b82f6, #8b5cf6, #06b6d4, #10b981);
    border-radius: 16px 16px 0 0;
  }

  .class-tags-header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 8px;
  }

  .tags-label {
    font-weight: 700;
    color: #1e293b;
    margin-right: 12px;
    margin-bottom: 0;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .tags-label::before {
    content: '📚';
    font-size: 18px;
  }

  .class-tag {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 28px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    border: none;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.12);
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 44px;
  }

  .class-tag::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
    transition: left 0.6s ease;
  }

  .class-tag::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease;
  }

  .class-tag:hover {
    transform: translateY(-4px) scale(1.05);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.18);
  }

  .class-tag:hover::before {
    left: 100%;
  }

  .class-tag:hover::after {
    width: 100%;
    height: 100%;
  }

  .class-tag:active {
    transform: translateY(-2px) scale(1.02);
  }

  /* 班级标签加载动画 */
  .class-tag {
    animation: slideInUp 0.6s ease-out;
  }

  .class-tag:nth-child(1) { animation-delay: 0.1s; }
  .class-tag:nth-child(2) { animation-delay: 0.2s; }
  .class-tag:nth-child(3) { animation-delay: 0.3s; }
  .class-tag:nth-child(4) { animation-delay: 0.4s; }
  .class-tag:nth-child(5) { animation-delay: 0.5s; }

  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* 班级标签选中动画 */
  .class-tag.el-tag--primary {
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
    }
    50% {
      box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6);
    }
    100% {
      box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
    }
  }

  .submission-count {
    font-weight: 700;
    margin-left: 6px;
    opacity: 0.95;
    background: rgba(255, 255, 255, 0.2);
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
  }

  /* 选中状态的班级标签 - 渐变蓝色 */
  .class-tag.el-tag--primary {
    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 50%, #1e40af 100%);
    color: white;
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
    border: 2px solid rgba(255, 255, 255, 0.2);
  }

  .class-tag.el-tag--primary:hover {
    background: linear-gradient(135deg, #2563eb 0%, #1e40af 50%, #1e3a8a 100%);
    box-shadow: 0 10px 30px rgba(59, 130, 246, 0.5);
    border-color: rgba(255, 255, 255, 0.3);
  }

  .class-tag.el-tag--primary .submission-count {
    background: rgba(255, 255, 255, 0.25);
    color: white;
  }

  /* 未选中状态的班级标签 - 现代灰色 */
  .class-tag.el-tag--info {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #f1f5f9 100%);
    color: #475569;
    border: 2px solid #e2e8f0;
  }

  .class-tag.el-tag--info:hover {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%);
    border-color: #cbd5e1;
    color: #334155;
  }

  .class-tag.el-tag--info .submission-count {
    background: rgba(71, 85, 105, 0.1);
    color: #475569;
  }

  /* 班级标签内部元素样式 */
  .class-tag .class-icon {
    font-size: 16px;
    opacity: 0.8;
    transition: all 0.3s ease;
  }

  .class-tag.el-tag--primary .class-icon {
    opacity: 1;
    transform: scale(1.1);
  }

  .class-tag .class-name {
    font-weight: 600;
    margin: 0 4px;
  }

  .class-tag .class-id {
    font-size: 12px;
    opacity: 0.7;
    font-weight: 500;
    margin: 0 2px;
  }

  .class-tag.el-tag--primary .class-id {
    opacity: 0.9;
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .class-tags-container {
      padding: 16px;
      margin-bottom: 16px;
    }

    .class-tags-header {
      gap: 12px;
    }

    .class-tag {
      padding: 10px 20px;
      font-size: 13px;
      min-height: 40px;
    }

    .tags-label {
      font-size: 14px;
    }
  }

  /* 数学公式样式 */
  .question-title {
    line-height: 1.6;
  }

  .question-title .katex {
    font-size: 1em;
    display: inline;
  }

  .question-title .katex-display {
    margin: 0.5em 0;
    text-align: center;
    display: block;
  }

  /* 确保数学公式在题目内容中正确显示 */
  .question-content .katex {
    font-size: inherit;
    display: inline;
  }

  .question-content .katex-display {
    margin: 0.3em 0;
    text-align: left;
    display: block;
  }

  /* 确保KaTeX元素可见 */
  .katex {
    font-family: KaTeX_Main, "Times New Roman", serif;
    font-size: 1em;
    line-height: 1.2;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .katex .base {
    display: inline-block;
  }

  .katex .mord {
    display: inline-block;
  }

  .katex .mrel {
    display: inline-block;
  }

  .katex .mbin {
    display: inline-block;
  }

  .katex .mopen, .katex .mclose {
    display: inline-block;
  }

  /* 确保题目内容不被截断 */
  .question-title {
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    max-width: 100%;
  }

  .question-content {
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    max-width: 100%;
  }

  /* 上传作业图片弹窗样式 */
  .upload-container {
    padding: 20px;
  }

  .upload-info {
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;
  }

  .upload-info p {
    margin: 8px 0;
    color: #495057;
    font-size: 14px;
  }

  .upload-info strong {
    color: #212529;
    font-weight: 600;
  }

  .upload-area {
    border: 2px dashed #d9d9d9;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    transition: border-color 0.3s;
  }

  .upload-area:hover {
    border-color: #409EFF;
  }

  .upload-area .el-upload-dragger {
    width: 100%;
    height: auto;
    border: none;
    background: transparent;
  }

  .upload-area .el-upload-dragger:hover {
    background: transparent;
  }

  /* 确保题目列表项不被截断 */
  .question-item {
    width: 100%;
    overflow: visible;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .question-item .question-content {
    width: 100%;
    overflow: visible;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  /* 确保el-checkbox不会截断内容 */
  .question-item .el-checkbox {
    width: 100%;
    display: block;
  }

  .question-item .el-checkbox__label {
    width: 100%;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  /* 学生答案样式 */
  .student-answer {
    padding: 8px;
  }

  .answer-text {
    margin-bottom: 8px;
  }

  .answer-text strong {
    color: #409EFF;
    font-size: 12px;
  }

  .answer-text div {
    margin-top: 4px;
    padding: 6px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #409EFF;
  }

  .answer-image {
    margin-bottom: 8px;
  }

  .answer-image strong {
    color: #409EFF;
    font-size: 12px;
  }

  .answer-image img {
    margin-top: 4px;
    transition: transform 0.2s;
  }

  .answer-image img:hover {
    transform: scale(1.05);
  }

  .no-answer {
    color: #999;
    font-style: italic;
    text-align: center;
    padding: 20px;
  }
  </style>
